<template>
	<div class="submittedApplications" v-if="$can('application_view')">
		<v-snackbar v-model="snackbar" :timeout="4000" bottom right :color="color">
			<span>{{ message }}</span>
		</v-snackbar>
		<v-dialog
            transition="dialog-bottom-transition"
            max-width="600"
            v-model="pdfViewDialog"
        >
            <v-card max-width="600" v-if="assignedApplication!=null">
				<v-toolbar flat>
					{{ docType }}
					<v-spacer></v-spacer>
					<v-btn icon @click="closePDFView()" >
						<v-icon class="primary--text">mdi-close</v-icon>
					</v-btn>
				</v-toolbar>
                <v-card-text>                    
					<!-- <div align="right">
						<v-btn icon @click="$refs.myPdfComponent.print()"><v-icon class="primary--text">mdi-printer</v-icon></v-btn>
					</div>
					<pdf v-if="docType == 'CR12'"
						ref="myPdfComponent"
						:src="path+'/storage/docs/'+ assignedApplication.user.venture.cr12"
						@num-pages="pageCount = $event"
						@page-loaded="currentPage = $event"
					></pdf>
					<pdf v-else
						ref="myPdfComponent"
						:src="path+'/storage/docs/'+ assignedApplication.user.venture.registration_cetificate"
						@num-pages="pageCount = $event"
						@page-loaded="currentPage = $event"
					></pdf> -->

					<div align="right">
						<v-btn icon @click="printPdf"><v-icon class="primary--text">mdi-printer</v-icon></v-btn>
					</div>
					<pdf						
						v-for="page in pageCount"
						:key="page"
						:src="pdfsrc"
						:page="page"
						/>
                </v-card-text>
            </v-card>
        </v-dialog>
		<v-container>
			<v-layout column>
				<div v-if="view == 'default'">
					<v-tabs show-arrows v-model="applicationTab" class="mt-5">
						<v-tabs-slider color="primary"></v-tabs-slider>

						<v-tab @click="activeTab = 'submitted'">
							<div class="text-none primary--text">
								Submitted ({{ submittedApplicationPagination.total }})
							</div>
						</v-tab>
						<v-tab @click="activeTab = 'review'">
							<div class="text-none primary--text">
								Review ({{ reviewApplicationPagination.total }})
							</div>
						</v-tab>
						<v-tab @click="activeTab = 'rejected'">
							<div class="text-none primary--text">
								Rejected ({{ rejectedApplicationPagination.total }})
							</div>
						</v-tab>
						<v-tab @click="activeTab = 'selectedForRating'">
							<div class="text-none primary--text">
								Selected for Rating ({{ selectedForRatingApplicationPagination.total }})
							</div>
						</v-tab>
						<v-tab @click="activeTab = 'shortlisted'">
							<div class="text-none primary--text">
								Shortlisted ({{ shortlistedApplicationPagination.total }})
							</div>
						</v-tab>
					</v-tabs>

					<div v-if="activeTab == 'submitted'">
						<v-card outlined class="mt-5 pa-3" style="border-radius: 25px;">
							<v-flex xs12 class="mt-10 mb-2">
								<div class="mx-5">
									<v-layout row wrap>
										<v-flex xs12 md4>
											<h1>Submitted Applications</h1>
										</v-flex>
										<v-flex xs12 md4>
											<div class="pa-1">
												<v-text-field class="text_field header" outlined dense label="Search"
													append-icon="mdi-undo-variant" @click:append="resetSearch()"
													v-on:keyup.enter="submittedSearch" v-model="searchTerm"
													@input="enableSearch()"></v-text-field>
											</div>

										</v-flex>
										<v-flex xs12 md2>
											<div class="pa-1">
												<v-btn class="secondary white--text text-none" depressed block
													@click="submittedSearch" :loading="searchLoader"
													:disabled="searchButtonDisabled">
													Search
													<v-icon right>mdi-magnify</v-icon>
												</v-btn>
											</div>
										</v-flex>
										<v-flex xs12 md2>
											<div class="pa-1">
												<v-btn class="primary white--text text-none" depressed block
													@click="csvDownload('submittedApplications')" :loading="csvLoading">
													Download CSV
													<v-icon right>mdi-microsoft-excel</v-icon>
												</v-btn>
											</div>
										</v-flex>
									</v-layout>
								</div>
							</v-flex>
							<div class="mx-5 mt-9">
								<v-progress-linear v-if="submittedApplicationLoader" height="1" indeterminate
									color="primary"></v-progress-linear>
							</div>
							<v-divider class="mx-5"></v-divider>
							<v-flex xs12 class="mt-5">
								<div v-if="submittedApplications.length == 0">
									<v-card elevation="0">
										<v-layout row wrap>
											<v-flex xs12 md1>
												<v-container fill-height fluid>
													<v-row align="center" justify="center">
														<v-col class="text-center">
															<v-icon large class="text--text">
																mdi-alert-circle-outline
															</v-icon>
														</v-col>
													</v-row>
												</v-container>
											</v-flex>
											<v-flex xs12 md11>
												<v-container fill-height fluid>
													<v-row align="center" justify="center">
														<v-col class="text-center"> No Application Found </v-col>
													</v-row>
												</v-container>
											</v-flex>
										</v-layout>
									</v-card>
								</div>
								<div v-else>
									<div class="hidden-sm-and-down">
										<v-card elevation="0" class="pa-2">
											<v-simple-table>
												<template v-slot:default>
													<thead class="header">
														<tr class="tableHeader">
															<th class="text-left text--text">#</th>
															<th class="text-left text--text">Images</th>
															<th class="text-left text--text">Principal Founder</th>
															<th class="text-left text--text">Venture</th>
															<th class="text-left text--text">Source</th>
															<th class="text-left text--text">Date Added</th>
															<th class="text-right text--text">Actions</th>
														</tr>
													</thead>
													<tbody>
														<tr v-for="(item, index) in submittedApplications" :key="item.id">
															<td>
																{{ index + 1 }}
															</td>
															<td>
																<v-avatar size="40" class="primary title white--text mx-1"
																	v-if="item.user.prof_pic == null">
																	{{ item.user.first_name[0] }}
																</v-avatar>
																<v-avatar size="40" class="primary title mx-1" v-else>
																	<img :src="path + '/storage/profile_pics/' + item.user.prof_pic"
																	>
																</v-avatar>
																<v-avatar size="40" class="primary title mx-1 white--text"
																	v-if="item.user.venture.image == null">
																	{{ item.user.venture.name[0] }}
																</v-avatar>
																<v-avatar size="40" class="primary title mx-1" v-else>
																	<img :src="path + '/storage/venture_logos/' + item.user.venture.image"
																	>
																</v-avatar>
															</td>
															<td>{{ item.user.first_name }} {{ item.user.middle_name }} {{ item.user.last_name }}</td>
															<td>{{ item.user.venture.name }}</td>
															<td>
																{{ item.marketing_source.name }}
															</td>
															<td>
																{{
																	item.created_at | moment("DD/MM/YYYY - hh:mm a")
																}}
															</td>
															<td>
																<div align="right">
																	<v-tooltip top v-if="$can('application_view')">
																		<template v-slot:activator="{ on, attrs }">
																			<v-btn icon class="button mr-1 universal--text"
																				@click="showApplication(item)">
																				<v-icon small> mdi-eye </v-icon>
																			</v-btn>
																		</template>
																		<span>View</span>
																	</v-tooltip>
																	<!-- <v-tooltip top v-if="$can('application_edit')">

																		<template v-slot:activator="{ on, attrs }">
																			<v-btn icon class="button mr-1 success--text"
																				@click="editApplication(item)" v-bind="attrs"
																				v-on="on">
																				<v-icon small> mdi-pencil </v-icon>
																			</v-btn>
																		</template>
																		<span>Edit</span>
																	</v-tooltip> -->

																	<v-tooltip top v-if="$can('application_archive')">
																		<template v-slot:activator="{ on, attrs }">
																			<v-btn icon class="button mr-1 error--text"
																				@click="deleteApplication(item)"
																				:loading="loading && applicationIndex == item.id"
																				v-bind="attrs" v-on="on">
																				<v-icon small> mdi-delete </v-icon>
																			</v-btn>
																		</template>
																		<span>delete</span>
																	</v-tooltip>

																	<v-tooltip top
																		v-if="$can('application_review')">

																		<template v-slot:activator="{ on, attrs }">
																			<v-btn icon class="button mr-1 green--text"
																				@click="applicationReview(item, 'reviewStage', 'up')"
																				:loading="upgradeLoading && applicationIndex == item.id"
																				v-bind="attrs" v-on="on">
																				<v-icon small> mdi-arrow-right
																				</v-icon>
																			</v-btn>
																		</template>
																		<span>Send For Review</span>
																	</v-tooltip>
																	<v-tooltip top v-if="$can('log_view')">

																		<template v-slot:activator="{ on, attrs }">
																			<v-btn icon class="button mr-1 purple--text"
																				@click="viewLog(item)" v-bind="attrs"
																				v-on="on">
																				<v-icon small> mdi-script-text </v-icon>
																			</v-btn>
																		</template>
																		<span>Log</span>
																	</v-tooltip>

																</div>
															</td>
														</tr>
													</tbody>
												</template>
											</v-simple-table>
										</v-card>

									</div>
									<div class="hidden-md-and-up">
										<v-layout column>

											<template v-for="(application, index) in submittedApplications">
												<div :key="index">
													<v-flex xs12 class="mb-2">
														<v-card elevation="0">
															<div class="pa-5">
																<v-layout column>
																	<v-flex xs12>
																		<v-layout row wrap>
																			<v-flex xs11>
																				<div class="title primary--text ml-3">
																					<b>{{ application.user.venture.name }} </b>
																				</div>
																			</v-flex>
																			<v-flex xs1>
																				<v-btn depressed class="red--text" :loading="loading && applicationIndex == application.id
			" icon @click="deleteApplication(application)" v-if="$can('application_archive')">
																					<v-icon> mdi-delete </v-icon>
																				</v-btn>
																			</v-flex>
																		</v-layout>
																	</v-flex>
																	<v-divider class="mt-2"></v-divider>
																	<v-flex xs12 class="mt-1">
																		<v-layout column>
																			<v-flex xs12 class="mt-1">
																				<div>
																					<b>Principal Founder</b>
																				</div>
																				<div>
																					{{ application.user.first_name }} {{ application.user.middle_name }} {{ application.user.last_name }}
																				</div>
																			</v-flex>
																			<v-flex xs12 class="mt-1">
																				<div>
																					<b>Venture</b>
																				</div>
																				<div>
																					{{ application.user.first_name }} {{ application.user.middle_name }} {{ application.user.last_name }}
																				</div>
																			</v-flex>
																			<v-flex xs12 class="mt-1">
																				<div>
																					<b>Source</b>
																				</div>
																				<div>
																					{{
																						application.marketing_source.name
																					}}
																				</div>
																			</v-flex>
																			<v-flex xs12 class="mt-1">
																				<div>
																					<b>Date Added</b>
																				</div>
																				<div>
																					{{
																						application.created_at
																						| moment("DD/MM/YYYY - hh:mm a")
																					}}
																				</div>
																			</v-flex>
																			<v-flex xs12 class="mt-5">
																				<v-layout row wrap>
																					<v-flex xs12>
																						<div class="pa-1">
																							<v-btn
																								v-if="$can('application_view')"
																								depressed class="
																								primary
																								text-none
																								white--text
																								" block @click="showApplication(application)">View
																								<v-icon right> mdi-eye
																								</v-icon>
																							</v-btn>
																						</div>
																					</v-flex>
																					<!-- <v-flex xs12>
																						<div class="pa-1">
																							<v-btn depressed
																								class="blue text-none white--text"
																								block
																								@click="editApplication(application)"
																								v-if="$can('application_edit')">Edit
																								<v-icon right>
																									mdi-border-color
																								</v-icon>
																							</v-btn>
																						</div>
																					</v-flex> -->
																					<v-flex xs12>
																						<div class="pa-1">
																							<v-btn depressed
																								class="green text-none white--text"
																								block
																								@click="applicationReview(application, 'reviewStage', 'up')"
																								:loading="upgradeLoading && applicationIndex == application.id"
																								v-if="$can('application_review')">Send For Review
																								<v-icon right>
																									mdi-arrow-right
																								</v-icon>
																							</v-btn>
																						</div>
																					</v-flex>
																					<v-flex xs12>
																						<div class="pa-1">
																							<v-btn v-if="$can('log_view')"
																								depressed class="
													purple
													text-none
													white--text
													" block @click="viewLog(application)">Log
																								<v-icon right>
																									mdi-script-text
																								</v-icon>
																							</v-btn>
																						</div>
																					</v-flex>
																				</v-layout>
																			</v-flex>
																		</v-layout>
																	</v-flex>
																</v-layout>
															</div>
														</v-card>
													</v-flex>
												</div>
											</template>
										</v-layout>
									</div>
								</div>
							</v-flex>
						</v-card>

						<v-layout column class="mt-5">
							<v-flex xs12>
								<div align="center">
									<v-pagination v-if="length != 0" :length="submittedApplicationLength" total-visible="10"
										v-model="submittedApplicationPagination.current_page" @input="changeSubmittedApplicationPage()" circle>
									</v-pagination>
								</div>
							</v-flex>
							<v-flex xs12>
								<div v-if="length != 0" align="center" class="mt-5">
									<b class="primary--text">Total: </b>{{ submittedApplicationPagination.total | formatNumber }}
								</div>
							</v-flex>
						</v-layout>
					</div>
					<div v-if="activeTab == 'review'">
						<v-card outlined class="mt-5 pa-3" style="border-radius: 25px;">
							<v-flex xs12 class="mt-10 mb-2">
								<div class="mx-5">
									<v-layout row wrap>
										<v-flex xs12 md4>
											<h1>Review Applications</h1>
										</v-flex>
										<v-flex xs12 md4>
											<div class="pa-1">
												<v-text-field class="text_field header" outlined dense label="Search"
													append-icon="mdi-undo-variant" @click:append="resetSearch()"
													v-on:keyup.enter="reviewSearch" v-model="searchTerm"
													@input="enableSearch()"></v-text-field>
											</div>

										</v-flex>
										<v-flex xs12 md2>
											<div class="pa-1">
												<v-btn class="secondary white--text text-none" depressed block
													@click="reviewSearch" :loading="searchLoader"
													:disabled="searchButtonDisabled">
													Search
													<v-icon right>mdi-magnify</v-icon>
												</v-btn>
											</div>
										</v-flex>
										<v-flex xs12 md2>
											<div class="pa-1">
												<v-btn class="primary white--text text-none" depressed block
													@click="csvDownload('reviewApplications')" :loading="csvLoading">
													Download CSV
													<v-icon right>mdi-microsoft-excel</v-icon>
												</v-btn>												
											</div>
										</v-flex>
									</v-layout>
								</div>
							</v-flex>
							<div class="mx-5 mt-9">
								<v-progress-linear v-if="reviewApplicationLoader" height="1" indeterminate
									color="primary"></v-progress-linear>
							</div>
							<v-divider class="mx-5"></v-divider>
							<v-flex xs12 class="mt-5">
								<div v-if="reviewApplications.length == 0">
									<v-card elevation="0">
										<v-layout row wrap>
											<v-flex xs12 md1>
												<v-container fill-height fluid>
													<v-row align="center" justify="center">
														<v-col class="text-center">
															<v-icon large class="primary--text">
																mdi-alert-circle-outline
															</v-icon>
														</v-col>
													</v-row>
												</v-container>
											</v-flex>
											<v-flex xs12 md11>
												<v-container fill-height fluid>
													<v-row align="center" justify="center">
														<v-col class="text-center"> No Application Found </v-col>
													</v-row>
												</v-container>
											</v-flex>
										</v-layout>
									</v-card>
								</div>
								<div v-else>
									<div class="hidden-sm-and-down">
										<v-card elevation="0" class="pa-2">
											<v-simple-table>
												<template v-slot:default>
													<thead class="header">
														<tr class="tableHeader">
															<th class="text-left text--text">#</th>
															<th class="text-left text--text">Images</th>
															<th class="text-left text--text">Principal Founder</th>
															<th class="text-left text--text">Venture</th>
															<th class="text-right text--text">Rating</th>
															<th class="text-left text--text">Source</th>
															<th class="text-left text--text">Date Added</th>
															<th class="text-right text--text">Actions</th>
														</tr>
													</thead>
													<tbody>
														<tr v-for="(item, index) in reviewApplications" :key="item.id">
															<td>
																{{ index + 1 }}
															</td>
															<td>
																<v-avatar size="40" class="primary title white--text mx-1"
																	v-if="item.user.prof_pic == null">
																	{{ item.user.first_name[0] }}
																</v-avatar>
																<v-avatar size="40" class="primary title mx-1" v-else>
																	<img :src="path + '/storage/profile_pics/' + item.user.prof_pic"
																	>
																</v-avatar>
																<v-avatar size="40" class="primary title mx-1 white--text"
																	v-if="item.user.venture.image == null">
																	{{ item.user.venture.name[0] }}
																</v-avatar>
																<v-avatar size="40" class="primary title mx-1" v-else>
																	<img :src="path + '/storage/venture_logos/' + item.user.venture.image"
																	>
																</v-avatar>
															</td>
															<td>{{ item.user.first_name }} {{ item.user.middle_name }} {{ item.user.last_name }}</td>
															<td>{{ item.user.venture.name }}</td>
															<td>
																<div align="right" v-if="item.applicationScore==0">
																	<i>Pending</i>
																</div>
																<div v-else>
																	<div align="right" class="red--text" v-if="item.applicationScore>0 && item.applicationScore<=33.33">
																		{{ item.applicationScore }}%
																	</div>
																	<div align="right" class="orange--text" v-if="item.applicationScore>33.33 && item.applicationScore<=66.66">
																		{{ item.applicationScore }}%
																	</div>
																	<div align="right" class="green--text" v-if="item.applicationScore>66.66">
																		{{ item.applicationScore }}%
																	</div>
																</div>																
															</td>
															<td>
																{{ item.marketing_source.name }}
															</td>
															<td>
																{{
																	item.created_at | moment("DD/MM/YYYY - hh:mm a")
																}}
															</td>
															<td>
																<div align="right">
																	<v-tooltip top v-if="$can('application_view')">
																		<template v-slot:activator="{ on, attrs }">
																			<v-btn icon class="button mr-1 universal--text"
																				@click="showApplication(item)">
																				<v-icon small> mdi-eye </v-icon>
																			</v-btn>
																		</template>
																		<span>View</span>
																	</v-tooltip>
																	<!-- <v-tooltip top v-if="$can('application_edit')">

																		<template v-slot:activator="{ on, attrs }">
																			<v-btn icon class="button mr-1 success--text"
																				@click="editApplication(item)" v-bind="attrs"
																				v-on="on">
																				<v-icon small> mdi-pencil </v-icon>
																			</v-btn>
																		</template>
																		<span>Edit</span>
																	</v-tooltip> -->

																	<v-tooltip top v-if="$can('application_archive')">
																		<template v-slot:activator="{ on, attrs }">
																			<v-btn icon class="button mr-1 error--text"
																				@click="deleteApplication(item)"
																				:loading="loading && applicationIndex == item.id"
																				v-bind="attrs" v-on="on">
																				<v-icon small> mdi-delete </v-icon>
																			</v-btn>
																		</template>
																		<span>delete</span>
																	</v-tooltip>

																	<v-tooltip top
																		v-if="$can('application_review')">

																		<template v-slot:activator="{ on, attrs }">
																			<v-btn icon class="button mr-1 red--text"
																				@click="applicationReview(item, 'rejectedStage', 'down')"
																				:loading="downgradeLoading && applicationIndex == item.id"
																				v-bind="attrs" v-on="on">
																				<v-icon small> mdi-cancel
																				</v-icon>
																			</v-btn>
																		</template>
																		<span>Reject Application</span>
																	</v-tooltip>
																	<v-tooltip top
																		v-if="$can('application_review')">

																		<template v-slot:activator="{ on, attrs }">
																			<v-btn icon class="button mr-1 green--text"
																				@click="applicationReview(item, 'selectedForRating', 'up')"
																				:loading="upgradeLoading && applicationIndex == item.id"
																				v-bind="attrs" v-on="on">
																				<v-icon small> mdi-arrow-right
																				</v-icon>
																			</v-btn>
																		</template>
																		<span>Select for Rating</span>
																	</v-tooltip>
																	<v-tooltip top v-if="$can('log_view')">

																		<template v-slot:activator="{ on, attrs }">
																			<v-btn icon class="button mr-1 purple--text"
																				@click="viewLog(item)" v-bind="attrs"
																				v-on="on">
																				<v-icon small> mdi-script-text </v-icon>
																			</v-btn>
																		</template>
																		<span>Log</span>
																	</v-tooltip>

																</div>
															</td>
														</tr>
													</tbody>
												</template>
											</v-simple-table>
										</v-card>

									</div>
									<div class="hidden-md-and-up">
										<v-layout column>

											<template v-for="(application, index) in reviewApplications">
												<div :key="index">
													<v-flex xs12 class="mb-2">
														<v-card elevation="0">
															<div class="pa-5">
																<v-layout column>
																	<v-flex xs12>
																		<v-layout row wrap>
																			<v-flex xs11>
																				<div class="title primary--text ml-3">
																					<b>{{ application.user.venture.name }} </b>
																				</div>
																			</v-flex>
																			<v-flex xs1>
																				<v-btn depressed class="red--text" :loading="loading && applicationIndex == application.id
			" icon @click="deleteApplication(application)" v-if="$can('application_archive')">
																					<v-icon> mdi-delete </v-icon>
																				</v-btn>
																			</v-flex>
																		</v-layout>
																	</v-flex>
																	<v-divider class="mt-2"></v-divider>
																	<v-flex xs12 class="mt-1">
																		<v-layout column>
																			<v-flex xs12 class="mt-1">
																				<div>
																					<b>Principal Founder</b>
																				</div>
																				<div>
																					{{ application.user.first_name }} {{ application.user.middle_name }} {{ application.user.last_name }}
																				</div>
																			</v-flex>
																			<v-flex xs12 class="mt-1">
																				<div>
																					<b>Venture</b>
																				</div>
																				<div>
																					{{ application.user.first_name }} {{ application.user.middle_name }} {{ application.user.last_name }}
																				</div>
																			</v-flex>
																			<v-flex xs12 class="mt-1">
																				<div>
																					<b>Rating</b>
																				</div>
																				<div>
																					<div v-if="application.applicationScore==0">
																						<i>Pending</i>
																					</div>
																					<div v-else>
																						<div class="red--text" v-if="application.applicationScore>0 && application.applicationScore<=33.33">
																							{{ application.applicationScore }}%
																						</div>
																						<div class="orange--text" v-if="application.applicationScore>33.33 && application.applicationScore<=66.66">
																							{{ application.applicationScore }}%
																						</div>
																						<div class="green--text" v-if="application.applicationScore>66.66">
																							{{ application.applicationScore }}%
																						</div>
																					</div>	
																				</div>
																			</v-flex>
																			<v-flex xs12 class="mt-1">
																				<div>
																					<b>Source</b>
																				</div>
																				<div>
																					{{
																						application.marketing_source.name
																					}}
																				</div>
																			</v-flex>
																			<v-flex xs12 class="mt-1">
																				<div>
																					<b>Date Added</b>
																				</div>
																				<div>
																					{{
																						application.created_at
																						| moment("DD/MM/YYYY - hh:mm a")
																					}}
																				</div>
																			</v-flex>
																			<v-flex xs12 class="mt-5">
																				<v-layout row wrap>
																					<v-flex xs12>
																						<div class="pa-1">
																							<v-btn
																								v-if="$can('application_view')"
																								depressed class="
																								primary
																								text-none
																								white--text
																								" block @click="showApplication(application)">View
																								<v-icon right> mdi-eye
																								</v-icon>
																							</v-btn>
																						</div>
																					</v-flex>
																					<!-- <v-flex xs12>
																						<div class="pa-1">
																							<v-btn depressed
																								class="blue text-none white--text"
																								block
																								@click="editApplication(application)"
																								v-if="$can('application_edit')">Edit
																								<v-icon right>
																									mdi-border-color
																								</v-icon>
																							</v-btn>
																						</div>
																					</v-flex> -->
																					<v-flex xs12>
																						<div class="pa-1">
																							<v-btn depressed
																								class="green text-none white--text"
																								block
																								@click="applicationReview(application, 'selectedForRating', 'up')"
																								:loading="upgradeLoading && applicationIndex == application.id"
																								v-if="$can('application_review')">Select for Rating
																								<v-icon right>
																									mdi-arrow-right
																								</v-icon>
																							</v-btn>
																						</div>
																					</v-flex>
																					<v-flex xs12>
																						<div class="pa-1">
																							<v-btn depressed
																								class="red text-none white--text"
																								block
																								@click="applicationReview(application, 'rejectedStage', 'down')"
																								:loading="downgradeLoading && applicationIndex == application.id"
																								v-if="$can('application_review')">Reject Application
																								<v-icon right>
																									mdi-cancel
																								</v-icon>
																							</v-btn>
																						</div>
																					</v-flex>
																					
																					<v-flex xs12>
																						<div class="pa-1">
																							<v-btn v-if="$can('log_view')"
																								depressed class="
													purple
													text-none
													white--text
													" block @click="viewLog(application)">Log
																								<v-icon right>
																									mdi-script-text
																								</v-icon>
																							</v-btn>
																						</div>
																					</v-flex>
																				</v-layout>
																			</v-flex>
																		</v-layout>
																	</v-flex>
																</v-layout>
															</div>
														</v-card>
													</v-flex>
												</div>
											</template>
										</v-layout>
									</div>
								</div>
							</v-flex>
						</v-card>

						<v-layout column class="mt-5">
							<v-flex xs12>
								<div align="center">
									<v-pagination v-if="length != 0" :length="reviewApplicationLength" total-visible="10"
										v-model="reviewApplicationPagination.current_page" @input="changeReviewApplicationPage()" circle>
									</v-pagination>
								</div>
							</v-flex>
							<v-flex xs12>
								<div v-if="length != 0" align="center" class="mt-5">
									<b class="primary--text">Total: </b>{{ reviewApplicationPagination.total | formatNumber }}
								</div>
							</v-flex>
						</v-layout>
					</div>
					<div v-if="activeTab == 'rejected'">
						<v-card outlined class="mt-5 pa-3" style="border-radius: 25px;">
							<v-flex xs12 class="mt-10 mb-2">
								<div class="mx-5">
									<v-layout row wrap>
										<v-flex xs12 md4>
											<h1>Rejected Applications</h1>
										</v-flex>
										<v-flex xs12 md4>
											<div class="pa-1">
												<v-text-field class="text_field header" outlined dense label="Search"
													append-icon="mdi-undo-variant" @click:append="resetSearch()"
													v-on:keyup.enter="rejectedSearch" v-model="searchTerm"
													@input="enableSearch()"></v-text-field>
											</div>

										</v-flex>
										<v-flex xs12 md2>
											<div class="pa-1">
												<v-btn class="secondary white--text text-none" depressed block
													@click="rejectedSearch" :loading="searchLoader"
													:disabled="searchButtonDisabled">
													Search
													<v-icon right>mdi-magnify</v-icon>
												</v-btn>
											</div>
										</v-flex>
										<v-flex xs12 md2>
											<div class="pa-1">
												<v-btn class="primary white--text text-none" depressed block
													@click="csvDownload('rejectedApplications')" :loading="csvLoading">
													Download CSV
													<v-icon right>mdi-microsoft-excel</v-icon>
												</v-btn>												
											</div>
										</v-flex>
									</v-layout>
								</div>
							</v-flex>
							<div class="mx-5 mt-9">
								<v-progress-linear v-if="rejectedApplicationLoader" height="1" indeterminate
									color="primary"></v-progress-linear>
							</div>
							<v-divider class="mx-5"></v-divider>
							<v-flex xs12 class="mt-5">
								<div v-if="rejectedApplications.length == 0">
									<v-card elevation="0">
										<v-layout row wrap>
											<v-flex xs12 md1>
												<v-container fill-height fluid>
													<v-row align="center" justify="center">
														<v-col class="text-center">
															<v-icon large class="primary--text">
																mdi-alert-circle-outline
															</v-icon>
														</v-col>
													</v-row>
												</v-container>
											</v-flex>
											<v-flex xs12 md11>
												<v-container fill-height fluid>
													<v-row align="center" justify="center">
														<v-col class="text-center"> No Application Found </v-col>
													</v-row>
												</v-container>
											</v-flex>
										</v-layout>
									</v-card>
								</div>
								<div v-else>
									<div class="hidden-sm-and-down">
										<v-card elevation="0" class="pa-2">
											<v-simple-table>
												<template v-slot:default>
													<thead class="header">
														<tr class="tableHeader">
															<th class="text-left text--text">#</th>
															<th class="text-left text--text">Images</th>
															<th class="text-left text--text">Principal Founder</th>
															<th class="text-left text--text">Venture</th>
															<th class="text-right text--text">Rating</th>
															<th class="text-left text--text">Source</th>
															<th class="text-left text--text">Date Added</th>
															<th class="text-right text--text">Actions</th>
														</tr>
													</thead>
													<tbody>
														<tr v-for="(item, index) in rejectedApplications" :key="item.id">
															<td>
																{{ index + 1 }}
															</td>
															<td>
																<v-avatar size="40" class="primary title white--text mx-1"
																	v-if="item.user.prof_pic == null">
																	{{ item.user.first_name[0] }}
																</v-avatar>
																<v-avatar size="40" class="primary title mx-1" v-else>
																	<img :src="path + '/storage/profile_pics/' + item.user.prof_pic"
																	>
																</v-avatar>
																<v-avatar size="40" class="primary title mx-1 white--text"
																	v-if="item.user.venture.image == null">
																	{{ item.user.venture.name[0] }}
																</v-avatar>
																<v-avatar size="40" class="primary title mx-1" v-else>
																	<img :src="path + '/storage/venture_logos/' + item.user.venture.image"
																	>
																</v-avatar>
															</td>
															<td>{{ item.user.first_name }} {{ item.user.middle_name }} {{ item.user.last_name }}</td>
															<td>{{ item.user.venture.name }}</td>
															<td>
																<div align="right" v-if="item.applicationScore==0">
																	<i>Pending</i>
																</div>
																<div v-else>
																	<div align="right" class="red--text" v-if="item.applicationScore>0 && item.applicationScore<=33.33">
																		{{ item.applicationScore }}%
																	</div>
																	<div align="right" class="orange--text" v-if="item.applicationScore>33.33 && item.applicationScore<=66.66">
																		{{ item.applicationScore }}%
																	</div>
																	<div align="right" class="green--text" v-if="item.applicationScore>66.66">
																		{{ item.applicationScore }}%
																	</div>
																</div>																
															</td>
															<td>
																{{ item.marketing_source.name }}
															</td>
															<td>
																{{
																	item.created_at | moment("DD/MM/YYYY - hh:mm a")
																}}
															</td>
															<td>
																<div align="right">
																	<v-tooltip top v-if="$can('application_view')">
																		<template v-slot:activator="{ on, attrs }">
																			<v-btn icon class="button mr-1 universal--text"
																				@click="showApplication(item)">
																				<v-icon small> mdi-eye </v-icon>
																			</v-btn>
																		</template>
																		<span>View</span>
																	</v-tooltip>
																	<!-- <v-tooltip top v-if="$can('application_edit')">

																		<template v-slot:activator="{ on, attrs }">
																			<v-btn icon class="button mr-1 success--text"
																				@click="editApplication(item)" v-bind="attrs"
																				v-on="on">
																				<v-icon small> mdi-pencil </v-icon>
																			</v-btn>
																		</template>
																		<span>Edit</span>
																	</v-tooltip> -->

																	<v-tooltip top v-if="$can('application_archive')">
																		<template v-slot:activator="{ on, attrs }">
																			<v-btn icon class="button mr-1 error--text"
																				@click="deleteApplication(item)"
																				:loading="loading && applicationIndex == item.id"
																				v-bind="attrs" v-on="on">
																				<v-icon small> mdi-delete </v-icon>
																			</v-btn>
																		</template>
																		<span>delete</span>
																	</v-tooltip>

																	<v-tooltip top
																		v-if="$can('application_review')">

																		<template v-slot:activator="{ on, attrs }">
																			<v-btn icon class="button mr-1 red--text"
																				@click="applicationReview(item, 'reviewStage', 'down')"
																				:loading="downgradeLoading && applicationIndex == item.id"
																				v-bind="attrs" v-on="on">
																				<v-icon small> mdi-arrow-left
																				</v-icon>
																			</v-btn>
																		</template>
																		<span>Send Back to Review</span>
																	</v-tooltip>
																	<v-tooltip top
																		v-if="$can('application_review')">

																		<template v-slot:activator="{ on, attrs }">
																			<v-btn icon class="button mr-1 green--text"
																				@click="applicationReview(item, 'selectedForRating', 'up')"
																				:loading="upgradeLoading && applicationIndex == item.id"
																				v-bind="attrs" v-on="on">
																				<v-icon small> mdi-arrow-right
																				</v-icon>
																			</v-btn>
																		</template>
																		<span>Select for Rating</span>
																	</v-tooltip>
																	<v-tooltip top v-if="$can('log_view')">

																		<template v-slot:activator="{ on, attrs }">
																			<v-btn icon class="button mr-1 purple--text"
																				@click="viewLog(item)" v-bind="attrs"
																				v-on="on">
																				<v-icon small> mdi-script-text </v-icon>
																			</v-btn>
																		</template>
																		<span>Log</span>
																	</v-tooltip>

																</div>
															</td>
														</tr>
													</tbody>
												</template>
											</v-simple-table>
										</v-card>

									</div>
									<div class="hidden-md-and-up">
										<v-layout column>

											<template v-for="(application, index) in rejectedApplications">
												<div :key="index">
													<v-flex xs12 class="mb-2">
														<v-card elevation="0">
															<div class="pa-5">
																<v-layout column>
																	<v-flex xs12>
																		<v-layout row wrap>
																			<v-flex xs11>
																				<div class="title primary--text ml-3">
																					<b>{{ application.user.venture.name }} </b>
																				</div>
																			</v-flex>
																			<v-flex xs1>
																				<v-btn depressed class="red--text" :loading="loading && applicationIndex == application.id
			" icon @click="deleteApplication(application)" v-if="$can('application_archive')">
																					<v-icon> mdi-delete </v-icon>
																				</v-btn>
																			</v-flex>
																		</v-layout>
																	</v-flex>
																	<v-divider class="mt-2"></v-divider>
																	<v-flex xs12 class="mt-1">
																		<v-layout column>
																			<v-flex xs12 class="mt-1">
																				<div>
																					<b>Principal Founder</b>
																				</div>
																				<div>
																					{{ application.user.first_name }} {{ application.user.middle_name }} {{ application.user.last_name }}
																				</div>
																			</v-flex>
																			<v-flex xs12 class="mt-1">
																				<div>
																					<b>Venture</b>
																				</div>
																				<div>
																					{{ application.user.first_name }} {{ application.user.middle_name }} {{ application.user.last_name }}
																				</div>
																			</v-flex>
																			<v-flex xs12 class="mt-1">
																				<div>
																					<b>Rating</b>
																				</div>
																				<div>
																					<div v-if="application.applicationScore==0">
																						<i>Pending</i>
																					</div>
																					<div v-else>
																						<div class="red--text" v-if="application.applicationScore>0 && application.applicationScore<=33.33">
																							{{ application.applicationScore }}%
																						</div>
																						<div class="orange--text" v-if="application.applicationScore>33.33 && application.applicationScore<=66.66">
																							{{ application.applicationScore }}%
																						</div>
																						<div class="green--text" v-if="application.applicationScore>66.66">
																							{{ application.applicationScore }}%
																						</div>
																					</div>	
																				</div>
																			</v-flex>
																			<v-flex xs12 class="mt-1">
																				<div>
																					<b>Source</b>
																				</div>
																				<div>
																					{{
																						application.marketing_source.name
																					}}
																				</div>
																			</v-flex>
																			<v-flex xs12 class="mt-1">
																				<div>
																					<b>Date Added</b>
																				</div>
																				<div>
																					{{
																						application.created_at
																						| moment("DD/MM/YYYY - hh:mm a")
																					}}
																				</div>
																			</v-flex>
																			<v-flex xs12 class="mt-5">
																				<v-layout row wrap>
																					<v-flex xs12>
																						<div class="pa-1">
																							<v-btn
																								v-if="$can('application_view')"
																								depressed class="
																								primary
																								text-none
																								white--text
																								" block @click="showApplication(application)">View
																								<v-icon right> mdi-eye
																								</v-icon>
																							</v-btn>
																						</div>
																					</v-flex>
																					<!-- <v-flex xs12>
																						<div class="pa-1">
																							<v-btn depressed
																								class="blue text-none white--text"
																								block
																								@click="editApplication(application)"
																								v-if="$can('application_edit')">Edit
																								<v-icon right>
																									mdi-border-color
																								</v-icon>
																							</v-btn>
																						</div>
																					</v-flex> -->
																					<v-flex xs12>
																						<div class="pa-1">
																							<v-btn depressed
																								class="red text-none white--text"
																								block
																								@click="applicationReview(application, 'reviewStage', 'down')"
																								:loading="downgradeLoading && applicationIndex == application.id"
																								v-if="$can('application_review')">Send Back to Review
																								<v-icon right>
																									mdi-arrow-left
																								</v-icon>
																							</v-btn>
																						</div>
																					</v-flex>
																					<v-flex xs12>
																						<div class="pa-1">
																							<v-btn depressed
																								class="green text-none white--text"
																								block
																								@click="applicationReview(application, 'selectedForRating', 'up')"
																								:loading="upgradeLoading && applicationIndex == application.id"
																								v-if="$can('application_review')">Select for Rating
																								<v-icon right>
																									mdi-arrow-right
																								</v-icon>
																							</v-btn>
																						</div>
																					</v-flex>
																					<v-flex xs12>
																						<div class="pa-1">
																							<v-btn v-if="$can('log_view')"
																								depressed class="
													purple
													text-none
													white--text
													" block @click="viewLog(application)">Log
																								<v-icon right>
																									mdi-script-text
																								</v-icon>
																							</v-btn>
																						</div>
																					</v-flex>
																				</v-layout>
																			</v-flex>
																		</v-layout>
																	</v-flex>
																</v-layout>
															</div>
														</v-card>
													</v-flex>
												</div>
											</template>
										</v-layout>
									</div>
								</div>
							</v-flex>
						</v-card>

						<v-layout column class="mt-5">
							<v-flex xs12>
								<div align="center">
									<v-pagination v-if="length != 0" :length="rejectedApplicationLength" total-visible="10"
										v-model="rejectedApplicationPagination.current_page" @input="changeRejectedApplicationPage()" circle>
									</v-pagination>
								</div>
							</v-flex>
							<v-flex xs12>
								<div v-if="length != 0" align="center" class="mt-5">
									<b class="primary--text">Total: </b>{{ rejectedApplicationPagination.total | formatNumber }}
								</div>
							</v-flex>
						</v-layout>
					</div>
					<div v-if="activeTab == 'selectedForRating'">
						<v-card outlined class="mt-5 pa-3" style="border-radius: 25px;">
							<v-flex xs12 class="mt-10 mb-2">
								<div class="mx-5">
									<v-layout row wrap>
										<v-flex xs12 md4>
											<h1>Selected for Rating</h1>
										</v-flex>
										<v-flex xs12 md4>
											<div class="pa-1">
												<v-text-field class="text_field header" outlined dense label="Search"
													append-icon="mdi-undo-variant" @click:append="resetSearch()"
													v-on:keyup.enter="selectedForRatingSearch" v-model="searchTerm"
													@input="enableSearch()"></v-text-field>
											</div>

										</v-flex>
										<v-flex xs12 md2>
											<div class="pa-1">
												<v-btn class="secondary white--text text-none" depressed block
													@click="selectedForRatingSearch" :loading="searchLoader"
													:disabled="searchButtonDisabled">
													Search
													<v-icon right>mdi-magnify</v-icon>
												</v-btn>
											</div>
										</v-flex>
										<v-flex xs12 md2>
											<div class="pa-1">
												<v-btn class="primary white--text text-none" depressed block
													@click="csvDownload('selectedForRatingApplications')" :loading="csvLoading">
													Download CSV
													<v-icon right>mdi-microsoft-excel</v-icon>
												</v-btn>
											</div>
										</v-flex>
									</v-layout>
								</div>
							</v-flex>
							<div class="mx-5 mt-9">
								<v-progress-linear v-if="selectedForRatingApplicationLoader" height="1" indeterminate
									color="primary"></v-progress-linear>
							</div>
							<v-divider class="mx-5"></v-divider>
							<v-flex xs12 class="mt-5">
								<div v-if="selectedForRatingApplications.length == 0">
									<v-card elevation="0">
										<v-layout row wrap>
											<v-flex xs12 md1>
												<v-container fill-height fluid>
													<v-row align="center" justify="center">
														<v-col class="text-center">
															<v-icon large class="primary--text">
																mdi-alert-circle-outline
															</v-icon>
														</v-col>
													</v-row>
												</v-container>
											</v-flex>
											<v-flex xs12 md11>
												<v-container fill-height fluid>
													<v-row align="center" justify="center">
														<v-col class="text-center"> No Application Found </v-col>
													</v-row>
												</v-container>
											</v-flex>
										</v-layout>
									</v-card>
								</div>
								<div v-else>
									<div class="hidden-sm-and-down">
										<v-card elevation="0" class="pa-2">
											<v-simple-table>
												<template v-slot:default>
													<thead class="header">
														<tr class="tableHeader">
															<th class="text-left text--text">#</th>
															<th class="text-left text--text">Images</th>
															<th class="text-left text--text">Principal Founder</th>
															<th class="text-left text--text">Venture</th>
															<th class="text-right text--text">Rating</th>
															<th class="text-left text--text">Source</th>
															<th class="text-left text--text">Date Added</th>
															<th class="text-right text--text">Actions</th>
														</tr>
													</thead>
													<tbody>
														<tr v-for="(item, index) in selectedForRatingApplications" :key="item.id">
															<td>
																{{ index + 1 }}
															</td>
															<td>
																<v-avatar size="40" class="primary title white--text mx-1"
																	v-if="item.user.prof_pic == null">
																	{{ item.user.first_name[0] }}
																</v-avatar>
																<v-avatar size="40" class="primary title mx-1" v-else>
																	<img :src="path + '/storage/profile_pics/' + item.user.prof_pic"
																	>
																</v-avatar>
																<v-avatar size="40" class="primary title mx-1 white--text"
																	v-if="item.user.venture.image == null">
																	{{ item.user.venture.name[0] }}
																</v-avatar>
																<v-avatar size="40" class="primary title mx-1" v-else>
																	<img :src="path + '/storage/venture_logos/' + item.user.venture.image"
																	>
																</v-avatar>
															</td>
															<td>{{ item.user.first_name }} {{ item.user.middle_name }} {{ item.user.last_name }}</td>
															<td>{{ item.user.venture.name }}</td>
															<td>
																<div align="right" v-if="item.applicationScore==0">
																	<i>Pending</i>
																</div>
																<div v-else>
																	<div align="right" class="red--text" v-if="item.applicationScore>0 && item.applicationScore<=33.33">
																		{{ item.applicationScore }}%
																	</div>
																	<div align="right" class="orange--text" v-if="item.applicationScore>33.33 && item.applicationScore<=66.66">
																		{{ item.applicationScore }}%
																	</div>
																	<div align="right" class="green--text" v-if="item.applicationScore>66.66">
																		{{ item.applicationScore }}%
																	</div>
																</div>																
															</td>
															<td>
																{{ item.marketing_source.name }}
															</td>
															<td>
																{{
																	item.created_at | moment("DD/MM/YYYY - hh:mm a")
																}}
															</td>
															<td>
																<div align="right">
																	<v-tooltip top v-if="$can('application_view')">
																		<template v-slot:activator="{ on, attrs }">
																			<v-btn icon class="button mr-1 universal--text"
																				@click="showApplication(item)">
																				<v-icon small> mdi-eye </v-icon>
																			</v-btn>
																		</template>
																		<span>View</span>
																	</v-tooltip>
																	<!-- <v-tooltip top v-if="$can('application_edit')">

																		<template v-slot:activator="{ on, attrs }">
																			<v-btn icon class="button mr-1 success--text"
																				@click="editApplication(item)" v-bind="attrs"
																				v-on="on">
																				<v-icon small> mdi-pencil </v-icon>
																			</v-btn>
																		</template>
																		<span>Edit</span>
																	</v-tooltip> -->

																	<v-tooltip top v-if="$can('application_archive')">
																		<template v-slot:activator="{ on, attrs }">
																			<v-btn icon class="button mr-1 error--text"
																				@click="deleteApplication(item)"
																				:loading="loading && applicationIndex == item.id"
																				v-bind="attrs" v-on="on">
																				<v-icon small> mdi-delete </v-icon>
																			</v-btn>
																		</template>
																		<span>delete</span>
																	</v-tooltip>

																	<v-tooltip top
																		v-if="$can('application_review')">

																		<template v-slot:activator="{ on, attrs }">
																			<v-btn icon class="button mr-1 orange--text"
																				@click="applicationReview(item, 'reviewStage', 'down')"
																				:loading="downgradeLoading && applicationIndex == item.id"
																				v-bind="attrs" v-on="on">
																				<v-icon small> mdi-arrow-left
																				</v-icon>
																			</v-btn>
																		</template>
																		<span>Send Back to Review</span>
																	</v-tooltip>
																	<v-tooltip top
																		v-if="$can('application_review')">

																		<template v-slot:activator="{ on, attrs }">
																			<v-btn icon class="button mr-1 red--text"
																				@click="applicationReview(item, 'rejectedStage', 'downSpec')"
																				:loading="rejectLoading && applicationIndex == item.id"
																				v-bind="attrs" v-on="on">
																				<v-icon small> mdi-cancel
																				</v-icon>
																			</v-btn>
																		</template>
																		<span>Reject Application</span>
																	</v-tooltip>
																	<v-tooltip top
																		v-if="$can('application_review')">

																		<template v-slot:activator="{ on, attrs }">
																			<v-btn icon class="button mr-1 green--text"
																				@click="applicationReview(item, 'shortlisted', 'up')"
																				:loading="upgradeLoading && applicationIndex == item.id"
																				v-bind="attrs" v-on="on">
																				<v-icon small> mdi-arrow-right
																				</v-icon>
																			</v-btn>
																		</template>
																		<span>Shortlist Application</span>
																	</v-tooltip>
																	<v-tooltip top v-if="$can('log_view')">

																		<template v-slot:activator="{ on, attrs }">
																			<v-btn icon class="button mr-1 purple--text"
																				@click="viewLog(item)" v-bind="attrs"
																				v-on="on">
																				<v-icon small> mdi-script-text </v-icon>
																			</v-btn>
																		</template>
																		<span>Log</span>
																	</v-tooltip>

																</div>
															</td>
														</tr>
													</tbody>
												</template>
											</v-simple-table>
										</v-card>

									</div>
									<div class="hidden-md-and-up">
										<v-layout column>

											<template v-for="(application, index) in selectedForRatingApplications">
												<div :key="index">
													<v-flex xs12 class="mb-2">
														<v-card elevation="0">
															<div class="pa-5">
																<v-layout column>
																	<v-flex xs12>
																		<v-layout row wrap>
																			<v-flex xs11>
																				<div class="title primary--text ml-3">
																					<b>{{ application.user.venture.name }} </b>
																				</div>
																			</v-flex>
																			<v-flex xs1>
																				<v-btn depressed class="red--text" :loading="loading && applicationIndex == application.id
			" icon @click="deleteApplication(application)" v-if="$can('application_archive')">
																					<v-icon> mdi-delete </v-icon>
																				</v-btn>
																			</v-flex>
																		</v-layout>
																	</v-flex>
																	<v-divider class="mt-2"></v-divider>
																	<v-flex xs12 class="mt-1">
																		<v-layout column>
																			<v-flex xs12 class="mt-1">
																				<div>
																					<b>Principal Founder</b>
																				</div>
																				<div>
																					{{ application.user.first_name }} {{ application.user.middle_name }} {{ application.user.last_name }}
																				</div>
																			</v-flex>
																			<v-flex xs12 class="mt-1">
																				<div>
																					<b>Venture</b>
																				</div>
																				<div>
																					{{ application.user.first_name }} {{ application.user.middle_name }} {{ application.user.last_name }}
																				</div>
																			</v-flex>
																			<v-flex xs12 class="mt-1">
																				<div>
																					<b>Rating</b>
																				</div>
																				<div>
																					<div v-if="application.applicationScore==0">
																						<i>Pending</i>
																					</div>
																					<div v-else>
																						<div class="red--text" v-if="application.applicationScore>0 && application.applicationScore<=33.33">
																							{{ application.applicationScore }}%
																						</div>
																						<div class="orange--text" v-if="application.applicationScore>33.33 && application.applicationScore<=66.66">
																							{{ application.applicationScore }}%
																						</div>
																						<div class="green--text" v-if="application.applicationScore>66.66">
																							{{ application.applicationScore }}%
																						</div>
																					</div>	
																				</div>
																			</v-flex>
																			<v-flex xs12 class="mt-1">
																				<div>
																					<b>Source</b>
																				</div>
																				<div>
																					{{
																						application.marketing_source.name
																					}}
																				</div>
																			</v-flex>
																			<v-flex xs12 class="mt-1">
																				<div>
																					<b>Date Added</b>
																				</div>
																				<div>
																					{{
																						application.created_at
																						| moment("DD/MM/YYYY - hh:mm a")
																					}}
																				</div>
																			</v-flex>
																			<v-flex xs12 class="mt-5">
																				<v-layout row wrap>
																					<v-flex xs12>
																						<div class="pa-1">
																							<v-btn
																								v-if="$can('application_view')"
																								depressed class="
																								primary
																								text-none
																								white--text
																								" block @click="showApplication(application)">View
																								<v-icon right> mdi-eye
																								</v-icon>
																							</v-btn>
																						</div>
																					</v-flex>
																					<!-- <v-flex xs12>
																						<div class="pa-1">
																							<v-btn depressed
																								class="blue text-none white--text"
																								block
																								@click="editApplication(application)"
																								v-if="$can('application_edit')">Edit
																								<v-icon right>
																									mdi-border-color
																								</v-icon>
																							</v-btn>
																						</div>
																					</v-flex> -->
																					<v-flex xs12>
																						<div class="pa-1">
																							<v-btn depressed
																								class="orange text-none white--text"
																								block
																								@click="applicationReview(application, 'reviewStage', 'down')"
																								:loading="downgradeLoading && applicationIndex == application.id"
																								v-if="$can('application_review')">Send Back to Review
																								<v-icon right>
																									mdi-arrow-left
																								</v-icon>
																							</v-btn>
																						</div>
																					</v-flex>
																					<v-flex xs12>
																						<div class="pa-1">
																							<v-btn depressed
																								class="red text-none white--text"
																								block
																								@click="applicationReview(application, 'rejectedStage', 'downSpec')"
																								:loading="rejectLoading && applicationIndex == application.id"
																								v-if="$can('application_review')">Reject Application
																								<v-icon right>
																									mdi-cancel
																								</v-icon>
																							</v-btn>
																						</div>
																					</v-flex>
																					<v-flex xs12>
																						<div class="pa-1">
																							<v-btn depressed
																								class="green text-none white--text"
																								block
																								@click="applicationReview(application, 'shortlisted', 'up')"
																								:loading="upgradeLoading && applicationIndex == application.id"
																								v-if="$can('application_review')">Shortlist Application
																								<v-icon right>
																									mdi-arrow-right
																								</v-icon>
																							</v-btn>
																						</div>
																					</v-flex>
																					<v-flex xs12>
																						<div class="pa-1">
																							<v-btn v-if="$can('log_view')"
																								depressed class="
													purple
													text-none
													white--text
													" block @click="viewLog(application)">Log
																								<v-icon right>
																									mdi-script-text
																								</v-icon>
																							</v-btn>
																						</div>
																					</v-flex>
																				</v-layout>
																			</v-flex>
																		</v-layout>
																	</v-flex>
																</v-layout>
															</div>
														</v-card>
													</v-flex>
												</div>
											</template>
										</v-layout>
									</div>
								</div>
							</v-flex>
						</v-card>

						<v-layout column class="mt-5">
							<v-flex xs12>
								<div align="center">
									<v-pagination v-if="length != 0" :length="selectedForRatingApplicationLength" total-visible="10"
										v-model="selectedForRatingApplicationPagination.current_page" @input="changeSelectedForRatingApplicationPage()" circle>
									</v-pagination>
								</div>
							</v-flex>
							<v-flex xs12>
								<div v-if="length != 0" align="center" class="mt-5">
									<b class="primary--text">Total: </b>{{ selectedForRatingApplicationPagination.total | formatNumber }}
								</div>
							</v-flex>
						</v-layout>
					</div>
					<div v-if="activeTab == 'shortlisted'">
						<v-card outlined class="mt-5 pa-3" style="border-radius: 25px;">
							<v-flex xs12 class="mt-10 mb-2">
								<div class="mx-5">
									<v-layout row wrap>
										<v-flex xs12 md4>
											<h1>Shortlisted Applications</h1>
										</v-flex>
										<v-flex xs12 md4>
											<div class="pa-1">
												<v-text-field class="text_field header" outlined dense label="Search"
													append-icon="mdi-undo-variant" @click:append="resetSearch()"
													v-on:keyup.enter="shortlistedSearch" v-model="searchTerm"
													@input="enableSearch()"></v-text-field>
											</div>

										</v-flex>
										<v-flex xs12 md2>
											<div class="pa-1">
												<v-btn class="secondary white--text text-none" depressed block
													@click="shortlistedSearch" :loading="searchLoader"
													:disabled="searchButtonDisabled">
													Search
													<v-icon right>mdi-magnify</v-icon>
												</v-btn>
											</div>
										</v-flex>
										<v-flex xs12 md2>
											<div class="pa-1">
												<v-btn class="primary white--text text-none" depressed block
													@click="csvDownload('shortlistedApplications')" :loading="csvLoading">
													Download CSV
													<v-icon right>mdi-microsoft-excel</v-icon>
												</v-btn>
											</div>
										</v-flex>
									</v-layout>
								</div>
							</v-flex>
							<div class="mx-5 mt-9">
								<v-progress-linear v-if="shortlistedApplicationLoader" height="1" indeterminate
									color="primary"></v-progress-linear>
							</div>
							<v-divider class="mx-5"></v-divider>
							<v-flex xs12 class="mt-5">
								<div v-if="shortlistedApplications.length == 0">
									<v-card elevation="0">
										<v-layout row wrap>
											<v-flex xs12 md1>
												<v-container fill-height fluid>
													<v-row align="center" justify="center">
														<v-col class="text-center">
															<v-icon large class="primary--text">
																mdi-alert-circle-outline
															</v-icon>
														</v-col>
													</v-row>
												</v-container>
											</v-flex>
											<v-flex xs12 md11>
												<v-container fill-height fluid>
													<v-row align="center" justify="center">
														<v-col class="text-center"> No Application Found </v-col>
													</v-row>
												</v-container>
											</v-flex>
										</v-layout>
									</v-card>
								</div>
								<div v-else>
									<div class="hidden-sm-and-down">
										<v-card elevation="0" class="pa-2">
											<v-simple-table>
												<template v-slot:default>
													<thead class="header">
														<tr class="tableHeader">
															<th class="text-left text--text">#</th>
															<th class="text-left text--text">Images</th>
															<th class="text-left text--text">Principal Founder</th>
															<th class="text-left text--text">Venture</th>
															<th class="text-right text--text">Rating</th>
															<th class="text-left text--text">Source</th>
															<th class="text-left text--text">Date Added</th>
															<th class="text-right text--text">Actions</th>
														</tr>
													</thead>
													<tbody>
														<tr v-for="(item, index) in shortlistedApplications" :key="item.id">
															<td>
																{{ index + 1 }}
															</td>
															<td>
																<v-avatar size="40" class="primary title white--text mx-1"
																	v-if="item.user.prof_pic == null">
																	{{ item.user.first_name[0] }}
																</v-avatar>
																<v-avatar size="40" class="primary title mx-1" v-else>
																	<img :src="path + '/storage/profile_pics/' + item.user.prof_pic"
																	>
																</v-avatar>
																<v-avatar size="40" class="primary title mx-1 white--text"
																	v-if="item.user.venture.image == null">
																	{{ item.user.venture.name[0] }}
																</v-avatar>
																<v-avatar size="40" class="primary title mx-1" v-else>
																	<img :src="path + '/storage/venture_logos/' + item.user.venture.image"
																	>
																</v-avatar>
															</td>
															<td>{{ item.user.first_name }} {{ item.user.middle_name }} {{ item.user.last_name }}</td>
															<td>{{ item.user.venture.name }}</td>
															<td>
																<div align="right" v-if="item.applicationScore==0">
																	<i>Pending</i>
																</div>
																<div v-else>
																	<div align="right" class="red--text" v-if="item.applicationScore>0 && item.applicationScore<=33.33">
																		{{ item.applicationScore }}%
																	</div>
																	<div align="right" class="orange--text" v-if="item.applicationScore>33.33 && item.applicationScore<=66.66">
																		{{ item.applicationScore }}%
																	</div>
																	<div align="right" class="green--text" v-if="item.applicationScore>66.66">
																		{{ item.applicationScore }}%
																	</div>
																</div>																
															</td>
															<td>
																{{ item.marketing_source.name }}
															</td>
															<td>
																{{
																	item.created_at | moment("DD/MM/YYYY - hh:mm a")
																}}
															</td>
															<td>
																<div align="right">
																	<v-tooltip top v-if="$can('application_view')">
																		<template v-slot:activator="{ on, attrs }">
																			<v-btn icon class="button mr-1 universal--text"
																				@click="showApplication(item)">
																				<v-icon small> mdi-eye </v-icon>
																			</v-btn>
																		</template>
																		<span>View</span>
																	</v-tooltip>
																	<!-- <v-tooltip top v-if="$can('application_edit')">

																		<template v-slot:activator="{ on, attrs }">
																			<v-btn icon class="button mr-1 success--text"
																				@click="editApplication(item)" v-bind="attrs"
																				v-on="on">
																				<v-icon small> mdi-pencil </v-icon>
																			</v-btn>
																		</template>
																		<span>Edit</span>
																	</v-tooltip> -->

																	<v-tooltip top v-if="$can('application_archive')">
																		<template v-slot:activator="{ on, attrs }">
																			<v-btn icon class="button mr-1 error--text"
																				@click="deleteApplication(item)"
																				:loading="loading && applicationIndex == item.id"
																				v-bind="attrs" v-on="on">
																				<v-icon small> mdi-delete </v-icon>
																			</v-btn>
																		</template>
																		<span>delete</span>
																	</v-tooltip>

																	<v-tooltip top
																		v-if="$can('application_review')">

																		<template v-slot:activator="{ on, attrs }">
																			<v-btn icon class="button mr-1 red--text"
																				@click="applicationReview(item, 'selectedForRating', 'down')"
																				:loading="downgradeLoading && applicationIndex == item.id"
																				v-bind="attrs" v-on="on">
																				<v-icon small> mdi-arrow-left
																				</v-icon>
																			</v-btn>
																		</template>
																		<span>Send Back to Rating</span>
																	</v-tooltip>
																	<v-tooltip top v-if="$can('log_view')">

																		<template v-slot:activator="{ on, attrs }">
																			<v-btn icon class="button mr-1 purple--text"
																				@click="viewLog(item)" v-bind="attrs"
																				v-on="on">
																				<v-icon small> mdi-script-text </v-icon>
																			</v-btn>
																		</template>
																		<span>Log</span>
																	</v-tooltip>

																</div>
															</td>
														</tr>
													</tbody>
												</template>
											</v-simple-table>
										</v-card>

									</div>
									<div class="hidden-md-and-up">
										<v-layout column>

											<template v-for="(application, index) in shortlistedApplications">
												<div :key="index">
													<v-flex xs12 class="mb-2">
														<v-card elevation="0">
															<div class="pa-5">
																<v-layout column>
																	<v-flex xs12>
																		<v-layout row wrap>
																			<v-flex xs11>
																				<div class="title primary--text ml-3">
																					<b>{{ application.user.venture.name }} </b>
																				</div>
																			</v-flex>
																			<v-flex xs1>
																				<v-btn depressed class="red--text" :loading="loading && applicationIndex == application.id
			" icon @click="deleteApplication(application)" v-if="$can('application_archive')">
																					<v-icon> mdi-delete </v-icon>
																				</v-btn>
																			</v-flex>
																		</v-layout>
																	</v-flex>
																	<v-divider class="mt-2"></v-divider>
																	<v-flex xs12 class="mt-1">
																		<v-layout column>
																			<v-flex xs12 class="mt-1">
																				<div>
																					<b>Principal Founder</b>
																				</div>
																				<div>
																					{{ application.user.first_name }} {{ application.user.middle_name }} {{ application.user.last_name }}
																				</div>
																			</v-flex>
																			<v-flex xs12 class="mt-1">
																				<div>
																					<b>Venture</b>
																				</div>
																				<div>
																					{{ application.user.first_name }} {{ application.user.middle_name }} {{ application.user.last_name }}
																				</div>
																			</v-flex>
																			<v-flex xs12 class="mt-1">
																				<div>
																					<b>Rating</b>
																				</div>
																				<div>
																					<div v-if="application.applicationScore==0">
																						<i>Pending</i>
																					</div>
																					<div v-else>
																						<div class="red--text" v-if="application.applicationScore>0 && application.applicationScore<=33.33">
																							{{ application.applicationScore }}%
																						</div>
																						<div class="orange--text" v-if="application.applicationScore>33.33 && application.applicationScore<=66.66">
																							{{ application.applicationScore }}%
																						</div>
																						<div class="green--text" v-if="application.applicationScore>66.66">
																							{{ application.applicationScore }}%
																						</div>
																					</div>	
																				</div>
																			</v-flex>
																			<v-flex xs12 class="mt-1">
																				<div>
																					<b>Source</b>
																				</div>
																				<div>
																					{{
																						application.marketing_source.name
																					}}
																				</div>
																			</v-flex>
																			<v-flex xs12 class="mt-1">
																				<div>
																					<b>Date Added</b>
																				</div>
																				<div>
																					{{
																						application.created_at
																						| moment("DD/MM/YYYY - hh:mm a")
																					}}
																				</div>
																			</v-flex>
																			<v-flex xs12 class="mt-5">
																				<v-layout row wrap>
																					<v-flex xs12>
																						<div class="pa-1">
																							<v-btn
																								v-if="$can('application_view')"
																								depressed class="
																								primary
																								text-none
																								white--text
																								" block @click="showApplication(application)">View
																								<v-icon right> mdi-eye
																								</v-icon>
																							</v-btn>
																						</div>
																					</v-flex>
																					<!-- <v-flex xs12>
																						<div class="pa-1">
																							<v-btn depressed
																								class="blue text-none white--text"
																								block
																								@click="editApplication(application)"
																								v-if="$can('application_edit')">Edit
																								<v-icon right>
																									mdi-border-color
																								</v-icon>
																							</v-btn>
																						</div>
																					</v-flex> -->
																					<v-flex xs12>
																						<div class="pa-1">
																							<v-btn depressed
																								class="red text-none white--text"
																								block
																								@click="applicationReview(application, 'selectedForRating', 'down')"
																								:loading="downgradeLoading && applicationIndex == application.id"
																								v-if="$can('application_review')">Send Back to Rating
																								<v-icon right>
																									mdi-arrow-left
																								</v-icon>
																							</v-btn>
																						</div>
																					</v-flex>
																					<v-flex xs12>
																						<div class="pa-1">
																							<v-btn v-if="$can('log_view')"
																								depressed class="
													purple
													text-none
													white--text
													" block @click="viewLog(application)">Log
																								<v-icon right>
																									mdi-script-text
																								</v-icon>
																							</v-btn>
																						</div>
																					</v-flex>
																				</v-layout>
																			</v-flex>
																		</v-layout>
																	</v-flex>
																</v-layout>
															</div>
														</v-card>
													</v-flex>
												</div>
											</template>
										</v-layout>
									</div>
								</div>
							</v-flex>
						</v-card>

						<v-layout column class="mt-5">
							<v-flex xs12>
								<div align="center">
									<v-pagination v-if="length != 0" :length="shortlistedApplicationLength" total-visible="10"
										v-model="selectedForRatingApplicationPagination.current_page" @input="changeSelectedForRatingApplicationPage()" circle>
									</v-pagination>
								</div>
							</v-flex>
							<v-flex xs12>
								<div v-if="length != 0" align="center" class="mt-5">
									<b class="primary--text">Total: </b>{{ shortlistedApplicationPagination.total | formatNumber }}
								</div>
							</v-flex>
						</v-layout>
					</div>

				</div>
	
				<div v-if="view == 'show'">
					<v-card outlined class="mt-5">
						<v-card-title class="tableHeader text--text">
							{{ assignedApplication.user.first_name }} {{ assignedApplication.user.middle_name }} {{ assignedApplication.user.last_name }} - {{ assignedApplication.user.venture.name }}
							<v-spacer></v-spacer>
							<v-btn icon @click="changeView('default')">
								<v-icon class="text--text"> mdi-close </v-icon>
							</v-btn>
						</v-card-title>
						<v-card-text>
							<div class="mt-2">
								<v-tabs show-arrows v-model="applicantTab">
									<v-tabs-slider color="primary"></v-tabs-slider>

									<v-tab @click="subTab = 'principalFounder'">
										<div class="text-none primary--text">Principal Founder</div>
									</v-tab>
									<v-tab @click="subTab = 'venture'">
										<div class="text-none primary--text">
											Venture
										</div>
									</v-tab>
									<v-tab @click="subTab = 'problemSolution'">
										<div class="text-none primary--text">
											Problem/Solution
										</div>
									</v-tab>
									<v-tab @click="subTab = 'team'">
										<div class="text-none primary--text">
											Team
										</div>
									</v-tab>
									<v-tab @click="subTab = 'rating'">
										<div class="text-none primary--text">
											Rating
										</div>
									</v-tab>
									<!-- <v-tab @click="pdfDownload()" :loading="pdfLoading" class="pdf text-none white--text" style="border-radius: 5px;">
										<div class="mt-1">
											Download PDF
											<v-icon right class="white--text mb-1">mdi-file-pdf-box</v-icon>
										</div>
									</v-tab> -->
								</v-tabs>
								<div v-if="subTab == 'principalFounder'" class="mx-3 mt-7">
									<v-layout row wrap>
										<v-flex xs12 md3>
											<div align="center" class="mt-7">
												<v-avatar size="200" class="primary title white--text"
													v-if="assignedApplication.user.prof_pic == null">
													{{ assignedApplication.user.first_name[0] }}
												</v-avatar>
												<v-avatar size="200" class="primary title" v-else>
													<img :src="path + '/storage/profile_pics/' + assignedApplication.user.prof_pic"
													>
												</v-avatar>
											</div>
										</v-flex>
										<v-flex xs12 md9>
											<div class="pa-5">
												<v-layout row wrap>
													<v-flex xs12 md6>
														<v-layout column>
															<v-flex xs12 class="mt-7">
																<v-layout row wrap>
																	<v-flex xs12 md3>
																		<div><b>Name:</b></div>
																	</v-flex>
																	<v-flex xs12 md9>
																		{{ assignedApplication.user.first_name }} {{ assignedApplication.user.middle_name }} {{ assignedApplication.user.last_name }}
																	</v-flex>
																</v-layout>
															</v-flex>
															<v-flex xs12 class="mt-7">
																<v-layout row wrap>
																	<v-flex xs12 md3>
																		<div><b>Email Address:</b></div>
																	</v-flex>
																	<v-flex xs12 md9>
																		{{ assignedApplication.user.email }}
																	</v-flex>
																</v-layout>
															</v-flex>
															<v-flex xs12 class="mt-7">
																<v-layout row wrap>
																	<v-flex xs12 md3>
																		<div><b>Phone Number:</b></div>
																	</v-flex>
																	<v-flex xs12 md9>
																		{{ assignedApplication.user.phone }}
																	</v-flex>
																</v-layout>
															</v-flex>

														</v-layout>
													</v-flex>
													<v-flex xs12 md6>
														<v-layout column>
															<v-flex xs12 class="mt-7">
																<v-layout row wrap>
																	<v-flex xs12 md3>
																		<div><b>Gender:</b></div>
																	</v-flex>
																	<v-flex xs12 md9>
																		{{ assignedApplication.user.gender.name }}
																	</v-flex>
																</v-layout>
															</v-flex>
															<v-flex xs12 class="mt-7">
																<v-layout row wrap>
																	<v-flex xs12 md3>
																		<div><b>Nationality:</b></div>
																	</v-flex>
																	<v-flex xs12 md9>
																		{{ assignedApplication.user.country.name }}
																	</v-flex>
																</v-layout>
															</v-flex>
															<v-flex xs12 class="mt-7" v-if="assignedApplication.user.age_group_id != null">
																<v-layout row wrap>
																	<v-flex xs12 md3>
																		<div><b>Age:</b></div>
																	</v-flex>
																	<v-flex xs12 md9>
																		{{ assignedApplication.user.age_group.name }}
																	</v-flex>
																</v-layout>
															</v-flex>
															<v-flex xs12 class="mt-7" v-else>
																<v-layout row wrap>
																	<v-flex xs12 md3>
																		<div><b>Date of Birth:</b></div>
																	</v-flex>
																	<v-flex xs12 md9>
																		{{ assignedApplication.user.dob | moment("DD/MM/YYYY") }}
																	</v-flex>
																</v-layout>
															</v-flex>

														</v-layout>
													</v-flex>
													<v-flex xs12 class="mt-10">
														<v-layout row wrap>
															<v-flex xs12>
																<div><b>Socials</b></div>
															</v-flex>
														</v-layout>														
													</v-flex>
													<v-flex xs12 md6>
														<v-layout column>
															<v-flex xs12 class="mt-7">
																<v-layout row wrap>
																	<v-flex xs12 md3>
																		<div><b>LinkedIn:</b></div>
																	</v-flex>
																	<v-flex xs12 md9>
																		<div v-if="assignedApplication.user.linkedin_url!=null">
																			<a :href="assignedApplication.user.linkedin_url" style="text-decoration: none;">
																				{{ assignedApplication.user.linkedin_url }}
																			</a>
																		</div>
																		<div v-else>
																			N/A
																		</div>																		
																	</v-flex>
																</v-layout>
															</v-flex>
														</v-layout>
													</v-flex>
													<v-flex xs12 md6>
														<v-layout column>
															<v-flex xs12 class="mt-7">
																<v-layout row wrap>
																	<v-flex xs12 md3>
																		<div><b>X:</b></div>
																	</v-flex>
																	<v-flex xs12 md9>
																		<div v-if="assignedApplication.user.twitter_url!=null">
																			<a :href="assignedApplication.user.twitter_url" style="text-decoration: none;">
																				{{ assignedApplication.user.twitter_url }}
																			</a>
																		</div>
																		<div v-else>
																			N/A
																		</div>	
																	</v-flex>
																</v-layout>
															</v-flex>
														</v-layout>
													</v-flex>
													<v-flex xs12 class="mt-10">
														<v-layout row wrap>
															<v-flex xs12>
																<div><b>Bio</b></div>
															</v-flex>
														</v-layout>														
													</v-flex>
													<v-flex xs12>
														<v-layout column>
															<v-flex xs12 class="my-7">
																<v-layout row wrap>
																	<v-flex xs12>
																		<div v-if="assignedApplication.user.bio != null" v-html="assignedApplication.user.bio"></div>
																		<div v-else>N/A</div>
																	</v-flex>
																</v-layout>
															</v-flex>
														</v-layout>
													</v-flex>
												</v-layout>
												
											</div>
										</v-flex>
									</v-layout>
									
								</div>
								<div v-if="subTab == 'venture'" class="mx-3 mt-7">
									<v-layout row wrap>
										<v-flex xs12 md3>
											<div align="center" class="mt-7">
												<v-avatar size="200" class="primary title white--text"
													v-if="assignedApplication.user.venture.image == null">
													{{ assignedApplication.user.venture.name[0] }}
												</v-avatar>
												<v-avatar size="200" class="primary title" v-else>
													<img :src="path + '/storage/venture_logos/' + assignedApplication.user.venture.image"
													>
												</v-avatar>
											</div>
											
										</v-flex>
										<v-flex xs12 md9>
											<div class="pa-5">
												<v-layout row wrap>
													<v-flex xs12 md6>
														<v-layout column>
															<v-flex xs12 class="mt-7">
																<v-layout row wrap>
																	<v-flex xs12 md3>
																		<div><b>Name:</b></div>
																	</v-flex>
																	<v-flex xs12 md9>
																		{{ assignedApplication.user.venture.name }}
																	</v-flex>
																</v-layout>
															</v-flex>
															<v-flex xs12 class="mt-7">
																<v-layout row wrap>
																	<v-flex xs12 md3>
																		<div><b>Organisation Type:</b></div>
																	</v-flex>
																	<v-flex xs12 md9>
																		{{ assignedApplication.user.venture.organisation_type.name }}
																	</v-flex>
																</v-layout>
															</v-flex>
															<v-flex xs12 class="mt-7">
																<v-layout row wrap>
																	<v-flex xs12 md3>
																		<div><b>Email Address:</b></div>
																	</v-flex>
																	<v-flex xs12 md9>
																		{{ assignedApplication.user.venture.email_address }}
																	</v-flex>
																</v-layout>
															</v-flex>
															<v-flex xs12 class="mt-7">
																<v-layout row wrap>
																	<v-flex xs12 md3>
																		<div><b>Phone Number:</b></div>
																	</v-flex>
																	<v-flex xs12 md9>
																		{{ assignedApplication.user.venture.phone_number }}
																	</v-flex>
																</v-layout>
															</v-flex>
															<v-flex xs12 class="mt-7">
																<v-layout row wrap>
																	<v-flex xs12 md3>
																		<div><b>Stage:</b></div>
																	</v-flex>
																	<v-flex xs12 md9>
																		{{ assignedApplication.user.venture.step.name }}
																	</v-flex>
																</v-layout>
															</v-flex>

														</v-layout>
													</v-flex>
													<v-flex xs12 md6>
														<v-layout column>
															<v-flex xs12 class="mt-7">
																<v-layout row wrap>
																	<v-flex xs12 md3>
																		<div><b>Established:</b></div>
																	</v-flex>
																	<v-flex xs12 md9>
																		<div v-if="assignedApplication.user.venture.year_established != null">
																			{{ assignedApplication.user.venture.year_established }}
																		</div>
																		<div v-else>
																			N/A
																		</div>
																	</v-flex>
																</v-layout>
															</v-flex>
															<v-flex xs12 class="mt-7">
																<v-layout row wrap>
																	<v-flex xs12 md3>
																		<div><b>Website:</b></div>
																	</v-flex>
																	<v-flex xs12 md9>
																		<div v-if="assignedApplication.user.venture.website_url != null">
																			{{ assignedApplication.user.venture.website_url }}
																		</div>
																		<div v-else>
																			N/A
																		</div>
																	</v-flex>
																</v-layout>
															</v-flex>
															<v-flex xs12 class="mt-7">
																<v-layout row wrap>
																	<v-flex xs12 md3>
																		<div><b>
																			Video Pitch:</b></div>
																	</v-flex>
																	<v-flex xs12 md9>
																		<div v-if="assignedApplication.user.venture.video_pitch_url != null">
																			{{ assignedApplication.user.venture.video_pitch_url }}
																		</div>
																		<div v-else>
																			N/A
																		</div>
																	</v-flex>
																</v-layout>
															</v-flex>
															<v-flex xs12 class="mt-7">
																<v-layout row wrap>
																	<v-flex xs12 md3>
																		<div><b>Prev Funding:</b></div>
																	</v-flex>
																	<v-flex xs12 md9>
																		<div v-if="assignedApplication.user.venture==1">
																			Yes
																		</div>
																		<div v-else>
																			No
																		</div>
																		
																	</v-flex>
																</v-layout>
															</v-flex>

														</v-layout>
													</v-flex>
													<v-flex xs12 class="mt-10">
														<v-layout row wrap>
															<v-flex xs12>
																<div><b>Slogan</b></div>
															</v-flex>
														</v-layout>														
													</v-flex>
													<v-flex xs12>
														<v-layout column>
															<v-flex xs12 class="mt-7">
																<v-layout row wrap>
																	<v-flex xs12>
																		<div v-if="assignedApplication.user.venture.slogan != null">
																			{{ assignedApplication.user.venture.slogan }}
																		</div>
																		<div v-else>
																			N/A
																		</div>
																	</v-flex>
																</v-layout>
															</v-flex>
														</v-layout>
													</v-flex>
													<v-flex xs12 class="mt-7">
														<v-layout row wrap>
															<v-flex xs12>
																<div><b>Physical Address</b></div>
															</v-flex>
														</v-layout>														
													</v-flex>
													<v-flex xs12>
														<v-layout column>
															<v-flex xs12 class="mt-7">
																<v-layout row wrap>
																	<v-flex xs12>
																		<div v-if="assignedApplication.user.venture.physical_address != null">
																			{{ assignedApplication.user.venture.physical_address }}
																		</div>
																		<div v-else>
																			N/A
																		</div>
																	</v-flex>
																</v-layout>
															</v-flex>
														</v-layout>
													</v-flex>

													
													<v-flex xs12 md6>
														<v-layout column>
															<v-flex xs12 class="mt-10">
																<v-layout row wrap>
																	<v-flex xs12 md3>
																		<div><b>Sectors:</b></div>
																	</v-flex>
																	<v-flex xs12 md9>
																		<v-layout column>
																			<template v-for="(sector, index) in assignedApplication.user.venture.venture_sectors">
																				<v-flex xs12>
																					{{ index+1 }}. {{ sector.sector.name }}
																				</v-flex>
																			</template>
																		</v-layout>
																	</v-flex>
																</v-layout>
															</v-flex>
															<v-flex xs12 class="mt-7">
																<v-layout row wrap>
																	<v-flex xs12 md3>
																		<div><b>Client Loc(s):</b></div>
																	</v-flex>
																	<v-flex xs12 md9>
																		<v-layout column>
																			<template v-for="(location, index) in assignedApplication.user.venture.venture_client_locations">
																				<v-flex xs12>
																					{{ index+1 }}. {{ location.client_location.name }}
																				</v-flex>
																			</template>
																		</v-layout>
																	</v-flex>
																</v-layout>
															</v-flex>
														</v-layout>
													</v-flex>
													<v-flex xs12 md6>
														<!-- <v-layout column>
															<v-flex xs12 class="mt-10">
																<v-layout row wrap>
																	<v-flex xs12 md3>
																		<div><b>Client Type(s):</b></div>
																	</v-flex>
																	<v-flex xs12 md9>
																		<v-layout column>
																			<template v-for="(type, index) in assignedApplication.user.venture.venture_client_types">
																				<v-flex xs12>
																					{{ index+1 }}. {{ type.client_type.name }}
																				</v-flex>
																			</template>
																		</v-layout>
																	</v-flex>
																</v-layout>
															</v-flex>
														</v-layout> -->


														<v-layout column>
															<v-flex xs12 class="mt-10">
																<v-layout row wrap>
																	<v-flex xs12 md3>
																		<div><b>Countr(ies):</b></div>
																	</v-flex>
																	<v-flex xs12 md9>
																		<v-layout column>
																			<template v-for="(country, index) in assignedApplication.user.venture.venture_countries">
																				<v-flex xs12>
																					{{ index+1 }}. {{ country.country.name }}
																				</v-flex>
																			</template>
																		</v-layout>
																	</v-flex>
																</v-layout>
															</v-flex>
														</v-layout>
													</v-flex>
													<v-flex xs12 class="mt-7">
														<div class="my-5 mx-16">
															<v-divider></v-divider>
														</div>
													</v-flex>
													<v-flex xs12 md6>
														<div class="mx-1 my-5" align="center">
															<v-layout row wrap class="mt-2">
																<v-flex xs12 md6>
																	<div class="mt-2">
																		CR12 Certificate
																	</div>
																</v-flex>
																<v-flex xs12 md6>
																	<v-btn depressed color="#F40F02" class="white--text text-none" @click="viewDocument('CR12')">
																		View File <v-icon right small>mdi-file-pdf-box</v-icon>
																	</v-btn>
																</v-flex>
															</v-layout>
														</div>
													</v-flex>
													<v-flex xs12 md6>
														<div class="mx-1 my-5" align="center">
															<v-layout row wrap class="mt-2">
																<v-flex xs12 md6>
																	<div class="mt-2">
																		Registration Cetificate
																	</div>
																</v-flex>
																<v-flex xs12 md6>
																	<v-btn depressed color="#F40F02" class="white--text text-none" @click="viewDocument('Registration Cetificate')">
																		View File <v-icon right small>mdi-file-pdf-box</v-icon>
																	</v-btn>
																</v-flex>
															</v-layout>
														</div>
													</v-flex>
													<v-flex xs12>
														<div class="mt-8 mb-5 mx-16">
															<v-divider></v-divider>
														</div>
													</v-flex>
													<v-flex xs12 class="mt-5">
														<v-layout row wrap>
															<v-flex xs12>
																<div><b>Socials</b></div>
															</v-flex>
														</v-layout>														
													</v-flex>
													<v-flex xs12 md6>
														<v-layout column>
															<v-flex xs12 class="mt-7">
																<v-layout row wrap>
																	<v-flex xs12 md3>
																		<div><b>X:</b></div>
																	</v-flex>
																	<v-flex xs12 md9>
																		<div v-if="assignedApplication.user.venture.x_url!=null">
																			<a :href="assignedApplication.user.venture.x_url" style="text-decoration: none;">
																				{{ assignedApplication.user.venture.x_url }}
																			</a>
																		</div>
																		<div v-else>
																			N/A
																		</div>	
																	</v-flex>
																</v-layout>
															</v-flex>
															<v-flex xs12 class="mt-7">
																<v-layout row wrap>
																	<v-flex xs12 md3>
																		<div><b>Facebook:</b></div>
																	</v-flex>
																	<v-flex xs12 md9>
																		<div v-if="assignedApplication.user.venture.facebook_url!=null">
																			<a :href="assignedApplication.user.venture.facebook_url" style="text-decoration: none;">
																				{{ assignedApplication.user.venture.facebook_url }}
																			</a>
																		</div>
																		<div v-else>
																			N/A
																		</div>	
																	</v-flex>
																</v-layout>
															</v-flex>
															<v-flex xs12 class="mt-7">
																<v-layout row wrap>
																	<v-flex xs12 md3>
																		<div><b>LinkedIn:</b></div>
																	</v-flex>
																	<v-flex xs12 md9>
																		<div v-if="assignedApplication.user.venture.linkedin_url!=null">
																			<a :href="assignedApplication.user.venture.linkedin_url" style="text-decoration: none;">
																				{{ assignedApplication.user.venture.linkedin_url }}
																			</a>
																		</div>
																		<div v-else>
																			N/A
																		</div>	
																	</v-flex>
																</v-layout>
															</v-flex>
														</v-layout>
													</v-flex>
													<v-flex xs12 md6>
														<v-layout column>
															<v-flex xs12 class="mt-7">
																<v-layout row wrap>
																	<v-flex xs12 md3>
																		<div><b>YouTube:</b></div>
																	</v-flex>
																	<v-flex xs12 md9>
																		<div v-if="assignedApplication.user.venture.youtube_url!=null">
																			<a :href="assignedApplication.user.venture.youtube_url" style="text-decoration: none;">
																				{{ assignedApplication.user.venture.youtube_url }}
																			</a>
																		</div>
																		<div v-else>
																			N/A
																		</div>	
																	</v-flex>
																</v-layout>
															</v-flex>
															<v-flex xs12 class="mt-7">
																<v-layout row wrap>
																	<v-flex xs12 md3>
																		<div><b>Instagram:</b></div>
																	</v-flex>
																	<v-flex xs12 md9>
																		<div v-if="assignedApplication.user.venture.instagram_url!=null">
																			<a :href="assignedApplication.user.venture.instagram_url" style="text-decoration: none;">
																				{{ assignedApplication.user.venture.instagram_url }}
																			</a>
																		</div>
																		<div v-else>
																			N/A
																		</div>	
																	</v-flex>
																</v-layout>
															</v-flex>
															<v-flex xs12 class="mt-7">
																<v-layout row wrap>
																	<v-flex xs12 md3>
																		<div><b>TikTok:</b></div>
																	</v-flex>
																	<v-flex xs12 md9>
																		<div v-if="assignedApplication.user.venture.tiktok_url!=null">
																			<a :href="assignedApplication.user.venture.tiktok_url" style="text-decoration: none;">
																				{{ assignedApplication.user.venture.tiktok_url }}
																			</a>
																		</div>
																		<div v-else>
																			N/A
																		</div>	
																	</v-flex>
																</v-layout>
															</v-flex>
														</v-layout>
													</v-flex>
													<v-flex xs12 class="mt-10">
														<v-layout row wrap>
															<v-flex xs12>
																<div><b>Company Overview</b></div>
															</v-flex>
														</v-layout>														
													</v-flex>
													<v-flex xs12>
														<v-layout column>
															<v-flex xs12 class="mt-7">
																<v-layout row wrap>
																	<v-flex xs12>
																		<div v-html="assignedApplication.user.venture.description"> </div>
																	</v-flex>
																</v-layout>
															</v-flex>
														</v-layout>
													</v-flex>
												</v-layout>												
											</div>
										</v-flex>
									</v-layout>
									
								</div>
								<div v-if="subTab == 'problemSolution'" class="mx-3 mt-7">
									<v-layout column>
										<div v-if="questions.length != 0">
												<template v-for="(question, index) in questions">
													<div :key="index">
														<v-flex xs12 class="my-2">
															<v-card class="mx-auto" elevation="0">
																<v-card-text>
																	<v-layout row wrap>
																		<v-flex xs1>
																			<div align="center" class="subtitle-1">
																				{{ index + 1 }}.
																			</div>
																		</v-flex>
																		<v-flex xs11>
																			<div class="subtitle-1">
																				<b>{{ question.question }}<span class="red--text" v-if="question.required==1">*</span></b>
																			</div>
																			<div class="font-italic caption">{{ question.description }}</div>
																			<div v-if="question.question_type.name == 'Single Select Multiple Choice Question'">
																				<v-radio-group
																					disabled
																					v-model="singleSelect[question.id]"
																					column>
																					<template v-for="(option, index) in question.multi_choice_options">
																						<div :key="index">
																							<v-radio
																								:label="option.option"
																								:value="option.id"
																								@change="checkOther(question.id, option, question)"></v-radio>
																						</div>
																					</template>
																					<div
																						v-if="otherQuestions[question.id] == true">
																							{{ openEnded[question.id] }}
																					</div>
																					<div v-if="childQuestions.length != 0"
																						class="mt-3">
																						<template
																							v-for="(question, index) in childQuestions[question.id]">
																							<div :key="index">
																								<v-flex xs12
																									class="my-2">
																									<v-card
																										:loading="loading"
																										class="mx-auto"
																										elevation="0">
																										<v-card-text>
																											<v-layout
																												row
																												wrap>
																												<v-flex
																													xs1>
																													<div align="center"
																														class="subtitle-1">
																														{{ index + 1 }}.
																													</div>
																												</v-flex>
																												<v-flex
																													xs11>
																													<div
																														class="subtitle-1">
																														<b>{{ question.question }}</b>
																													</div>
																													<div v-if="question.question_type.name == 'Single Select Multiple Choice Question'">
																														<v-radio-group
																															disabled
																															v-model="singleSelect[question.id]"
																															column>
																															<template
																																v-for="(option, index) in question.multi_choice_options">
																																<div
																																	:key="index">
																																	<v-radio
																																		:label="option.option"
																																		:value="option.id"
																																		@change="checkOther(question.id, option, question)"></v-radio>
																																</div>
																															</template>
																															<div
																																v-if="otherQuestions[question.id] == true">
																																	{{ openEnded[question.id] }}
																															</div>
																															<div
																																v-if="childQuestions.length != 0">
																																{{ childQuestions[question.id] }}
																															</div>
																														</v-radio-group>
																													</div>
																													<div v-if="question.question_type.name == 'Multi Part Single Select Multiple Choice Question'">
																														<div
																															class="mt-4">
																															<template
																																v-for="( multi_question, index ) in question.multi_part_questions">
																																<div :key="index">{{ multi_question.question }}
																																	<v-radio-group disabled
																																		v-model="multiPartSingleAnswers[multi_question.id]" column>
																																		<template
																																			v-for="(option, index) in multi_question.multi_part_options">
																																			<div
																																				:key="index">
																																				<v-radio
																																					:label="option.option"
																																					:value="option.id"
																																					@change="calculateProgress()"></v-radio>
																																			</div>
																																		</template>
																																	</v-radio-group>
																																</div>
																															</template>
																														</div>
																													</div>
																													<div v-if="question.question_type.name == 'Multi Select Multiple Choice Questions'">
																														<div
																															class="mt-4">
																															<template
																																v-for="(option, index) in question.multi_choice_options">
																																<v-checkbox
																																	disabled
																																	v-model="multiSelects"
																																	:key="index"
																																	:label="option.option"
																																	:value="option.id"
																																	@change="calculateProgress()"></v-checkbox>
																															</template>

																														</div>
																													</div>
																													<div v-if="question.question_type.name == 'Multi Part Multi Select Multiple Choice Question'">
																														<div
																															class="mt-4">
																															<template
																																v-for="(multi_question, index) in question.multi_part_questions">
																																<div :key="index">{{ multi_question.question }}
																																	<template
																																		v-for="(option, index) in multi_question.multi_part_options">
																																		<v-checkbox
																																			disabled
																																			v-model="multiPartMultiAnswers"
																																			:key="index"
																																			:label="option.option"
																																			:value="option.id"
																																			@change="calculateProgress()"></v-checkbox>
																																	</template>
																																</div>
																															</template>
																														</div>
																													</div>
																													<div v-if="question.question_type.name == 'Open Ended'">
																														<div
																															class="mt-3 mb-5" v-if="question.length<=25">
																																<div v-if="openEnded[question.id] != null">
																																	{{ openEnded[question.id] }}
																																</div>
																																<div v-else>
																																	N/A
																																</div>
																														</div>
																													</div>
																												</v-flex>
																											</v-layout>
																										</v-card-text>
																									</v-card>
																								</v-flex>
																							</div>
																						</template>
																					</div>
																				</v-radio-group>
																			</div>
																			<div v-if="question.question_type.name =='Multi Part Single Select Multiple Choice Question'">
																				<div class="mt-4">
																					<template v-for="(multi_question, index) in question.multi_part_questions">
																						<div :key="index">
																							{{ multi_question.question }}
																							<v-radio-group disabled v-model="multiPartSingleAnswers[multi_question.id]" column>
																								<template v-for="(option, index) in multi_question.multi_part_options">
																									<div :key="index">
																										<v-radio
																											:label="option.option"
																											:value="option.id">
																										</v-radio>
																									</div>
																								</template>
																							</v-radio-group>
																							<v-text-field
																								v-if="multi_question.question == 'Other'"
																								class="text_field mb-6"
																								outlined
																								disabled
																								v-model="openEnded[question.id]"
																								label="Please specify.."
																								required></v-text-field>
																						</div>
																					</template>
																				</div>
																			</div>
																			<div v-if="question.question_type.name == 'Multi Select Multiple Choice Questions'">
																				<div class="mt-4">
																					<template v-for="(option, index) in question.multi_choice_options">
																						<v-checkbox
																							disabled
																							v-model="multiSelects"
																							:key="index"
																							:label="option.option"
																							:value="option.id"></v-checkbox>
																					</template>
																				</div>
																			</div>
																			<div v-if="question.question_type.name =='Multi Part Multi Select Multiple Choice Question'">
																				<div class="mt-4">
																					<template v-for="(multi_question, index) in question.multi_part_questions">
																						<div :key="index">
																							{{ multi_question.question }}
																							<template v-for="(option, index) in multi_question.multi_part_options">
																								<v-checkbox
																									disabled
																									v-model="multiPartMultiAnswers"
																									:key="index"
																									:label="option.option"
																									:value="option.id"></v-checkbox>
																							</template>
																						</div>
																					</template>
																				</div>
																			</div>
																			<div v-if="question.question_type.name == 'Open Ended'">
																				<div class="mt-3 mb-5" v-if="question.length<=25 && question.length!=null">
																						<div v-if="openEnded[question.id] != null">
																							{{ openEnded[question.id] }}
																						</div>
																						<div v-else>
																							N/A
																						</div>
																				</div>
																				<div class="mt-3 mb-5" v-else>
																					<div v-html="openEnded[question.id]"></div>																					
																				</div>
																			</div>
																		</v-flex>
																	</v-layout>
																</v-card-text>
															</v-card>
														</v-flex>
													</div>
												</template>
											</div>
									</v-layout>
								</div>
								<div v-if="subTab == 'team'" class="mx-3 mt-7">
									<v-layout column>
										<v-flex xs12>
											<v-flex xs12 class="mt-2">
												<v-layout row wrap>
													<v-flex xs1 md1>
														(a)
													</v-flex>
													<v-flex xs11 md9>
														<div><b>Are any members of your founding team, C-Suite women?:</b></div>
													</v-flex>
													<v-flex xs12 md2>
														<div v-if="assignedApplication.user.venture.c_suite_women==1">
															Yes
														</div>
														<div v-if="assignedApplication.user.venture.c_suite_women==0">
															No
														</div>	
														<div v-if="assignedApplication.user.venture.c_suite_women==2">
															Do not wish to respond
														</div>
													</v-flex>
												</v-layout>
											</v-flex>
										</v-flex>
										<div v-if="assignedApplication.user.venture.c_suite_women==1" class="mt-7 mb-3">
											<v-layout row wrap>
												<v-flex xs1 md1>
													(b)
												</v-flex>
												<v-flex xs11 md11>
													<div class="mb-3"><b>C-Suite Members</b></div>
													<div v-if="assignedApplication.user.venture.venture_c_suite_members.length == 0">
														<v-layout row wrap>
															<v-flex xs12 md3>
																<div align="center" class="mb-5">
																	<v-avatar size="200" class="primary title">
																		<v-icon class="white--text" large>mdi-account-alert</v-icon>
																	</v-avatar>
																</div>
															</v-flex>
															<v-flex xs12 md9>
																<div align="left" class="mt-16"><b>No C-Suite Members Added</b></div>
															</v-flex>
														</v-layout>
													</div>
													<div v-else>
														<template v-for="(member, index) in assignedApplication.user.venture.venture_c_suite_members">
															<v-flex xs12 class="mb-10">
																<v-layout row wrap>
																	<v-flex xs2>
																		<div class="mt-1" align="center">
																			{{ index+1 }}.
																		</div>
																	</v-flex>
																	<v-flex xs10>
																		<v-layout row wrap>
																			<v-flex xs12 md6>
																				<v-layout column>
																					<v-flex xs12 class="mt-7">
																						<v-layout row wrap>
																							<v-flex xs12 md3>
																								<div><b>Title:</b></div>
																							</v-flex>
																							<v-flex xs12 md9>
																								{{ member.title }}
																							</v-flex>
																						</v-layout>
																					</v-flex>
																					<v-flex xs12 class="mt-7">
																						<v-layout row wrap>
																							<v-flex xs12 md3>
																								<div><b>Name:</b></div>
																							</v-flex>
																							<v-flex xs12 md9>
																								{{ member.first_name }} {{ member.middle_name }} {{ member.last_name }}
																							</v-flex>
																						</v-layout>
																					</v-flex>
																					<v-flex xs12 class="mt-7">
																						<v-layout row wrap>
																							<v-flex xs12 md3>
																								<div><b>Nationality:</b></div>
																							</v-flex>
																							<v-flex xs12 md9>
																								{{ member.country.name }}
																							</v-flex>
																						</v-layout>
																					</v-flex>
																					<v-flex xs12 class="mt-7">
																						<v-layout row wrap>
																							<v-flex xs12 md3>
																								<div><b>City:</b></div>
																							</v-flex>
																							<v-flex xs12 md9>
																								{{ member.city }}
																							</v-flex>
																						</v-layout>
																					</v-flex>
																				</v-layout>
																			</v-flex>
																			<v-flex xs12 md6>
																				<v-layout column>
																					<v-flex xs12 class="mt-7">
																						<v-layout row wrap>
																							<v-flex xs12 md3>
																								<div><b>Gender:</b></div>
																							</v-flex>
																							<v-flex xs12 md9>
																								{{ member.gender.name }}
																							</v-flex>
																						</v-layout>
																					</v-flex>
																					<v-flex xs12 class="mt-7">
																						<v-layout row wrap>
																							<v-flex xs12 md3>
																								<div><b>LinkedIn:</b></div>
																							</v-flex>
																							<v-flex xs12 md9>
																								<a :href="member.linkedin_url" target="_blank">{{ member.linkedin_url }}</a>
																							</v-flex>
																						</v-layout>
																					</v-flex>
																					
																				</v-layout>
																			</v-flex>
																		</v-layout>
																	</v-flex>
																</v-layout>
															</v-flex>
														</template>
													</div>
												</v-flex>
											</v-layout>
											
										</div>
										
										<v-flex xs12>
											<v-flex xs12 class="mt-7">
													<v-layout row wrap>
														<v-flex xs1 md1>
															(c)
														</v-flex>
														<v-flex xs11 md9>
															<div><b>How many part-time or contract employees work at your venture?:</b></div>
														</v-flex>
														<v-flex xs12 md2>
															{{ assignedApplication.user.venture.part_time_employee_count }}
														</v-flex>
													</v-layout>
												</v-flex>
										</v-flex>
										<v-flex xs12>
											<v-flex xs12 class="mt-7">
													<v-layout row wrap>
														<v-flex xs1 md1>
															(d)
														</v-flex>
														<v-flex xs11 md9>
															<div><b>How many full-time employees work at your venture?:</b></div>
														</v-flex>
														<v-flex xs12 md2>
															{{ assignedApplication.user.venture.full_time_employee_count }}
														</v-flex>
													</v-layout>
												</v-flex>
										</v-flex>
										<v-layout row wrap class="mt-4">
											<v-flex xs1 md1>
												(e)
											</v-flex>
											<v-flex xs11 md11>
												<div v-if="assignedApplication.user.venture.venture_team_members.length == 0" class="mt-7 mb-3">
													<v-layout row wrap>
														<v-flex xs12 md3>
															<div align="center" class="mb-5">
																<v-avatar size="200" class="primary title">
																	<v-icon class="white--text" large>mdi-account-alert</v-icon>
																</v-avatar>
															</div>
														</v-flex>
														<v-flex xs12 md9>
															<div align="left" class="mt-16"><b>No Team Members Added</b></div>
														</v-flex>
													</v-layout>
												</div>
												<div v-else class="mb-3">
													<div class="mb-3"><b>Team Members</b></div>
													<template v-for="(member, index) in assignedApplication.user.venture.venture_team_members">
														<v-flex xs12 class="mb-10">
															<v-layout row wrap>
																<v-flex xs2>
																	<div class="mt-1" align="center">
																		{{ index+1 }}.
																	</div>
																</v-flex>
																<v-flex xs10>
																	<v-layout row wrap>
																		<v-flex xs12 md6>
																			<v-layout column>
																				<v-flex xs12 class="mt-7">
																					<v-layout row wrap>
																						<v-flex xs12 md3>
																							<div><b>Name:</b></div>
																						</v-flex>
																						<v-flex xs12 md9>
																							{{ member.first_name }} {{ member.middle_name }} {{ member.last_name }}
																						</v-flex>
																					</v-layout>
																				</v-flex>
																				<v-flex xs12 class="mt-7">
																					<v-layout row wrap>
																						<v-flex xs12 md3>
																							<div><b>Role:</b></div>
																						</v-flex>
																						<v-flex xs12 md9>
																							{{ member.role }}
																						</v-flex>
																					</v-layout>
																				</v-flex>
																				<v-flex xs12 class="mt-7">
																					<v-layout row wrap>
																						<v-flex xs12 md3>
																							<div><b>Shares:</b></div>
																						</v-flex>
																						<v-flex xs12 md9>
																							<div v-if="member.shares != null">
																								{{ member.shares }}
																							</div>
																							<div v-else>
																								N/A
																							</div>
																						</v-flex>
																					</v-layout>
																				</v-flex>
																			</v-layout>
																		</v-flex>
																		<v-flex xs12 md6>
																			<v-layout column>
																				<v-flex xs12 class="mt-7">
																					<v-layout row wrap>
																						<v-flex xs12 md3>
																							<div><b>Gender:</b></div>
																						</v-flex>
																						<v-flex xs12 md9>
																							{{ member.gender.name }}
																						</v-flex>
																					</v-layout>
																				</v-flex>
																				<v-flex xs12 class="mt-7">
																					<v-layout row wrap>
																						<v-flex xs12 md3>
																							<div><b>Years Experience:</b></div>
																						</v-flex>
																						<v-flex xs12 md9>
																							<div v-if="member.years_experience!=null">
																								{{ member.years_experience }}
																							</div>
																							<div v-else>
																								N/A
																							</div>
																						</v-flex>
																					</v-layout>
																				</v-flex>
																				<v-flex xs12 class="mt-7">
																					<v-layout row wrap>
																						<v-flex xs12 md3>
																							<div><b>Is a Founder:</b></div>
																						</v-flex>
																						<v-flex xs12 md9>
																							<div v-if="member.founder == 1">
																								Yes
																							</div>
																							<div v-else>
																								No
																							</div>
																						</v-flex>
																					</v-layout>
																				</v-flex>
																			</v-layout>
																		</v-flex>
																	</v-layout>
																</v-flex>
															</v-layout>
														</v-flex>
													</template>
												</div>
											</v-flex>
										</v-layout>
									</v-layout>
								</div>
								<div v-if="subTab == 'rating'" class="mx-3 mt-7">
									<v-layout column class="mt-5">
										<div v-if="formData.ratings.length != 0">
											<v-flex xs12 class="mb-10">
												<v-layout row wrap>
													<v-flex xs12 md2>
														<b>Overall Rating:</b>
													</v-flex>
													<v-flex xs12 md10>
														<div v-if="assignedApplication.applicationScore == 0">
															<i>Pending</i>
														</div>
														<div v-else>
															<div class="red--text" v-if="assignedApplication.applicationScore>0 && assignedApplication.applicationScore<=33.33">
																{{ assignedApplication.applicationScore }}%
															</div>
															<div class="orange--text" v-if="assignedApplication.applicationScore>33.33 && assignedApplication.applicationScore<=66.66">
																{{ assignedApplication.applicationScore }}%
															</div>
															<div class="green--text" v-if="assignedApplication.applicationScore>66.66">
																{{ assignedApplication.applicationScore }}%
															</div>
														</div>
													</v-flex>
												</v-layout>
											</v-flex>
											<template v-for="(applicationRating, index1) in assignedApplication.applicationRatings">
												<div :key="index">
													<v-layout column>
														<v-flex xs12 class="mt-3">
															<v-layout row wrap>
																<v-flex xs12 md2>
																	<b>Rated by:</b>
																</v-flex>
																<v-flex xs12 md10>
																	{{ applicationRating.judge.first_name }} {{ applicationRating.judge.middle_name }} {{ applicationRating.judge.last_name }}
																</v-flex>
															</v-layout>
														</v-flex>
														<v-flex xs12 class="mt-5">
															<v-layout row wrap>
																<v-flex xs12 md2>
																	<b>Judge Score:</b>
																</v-flex>
																<v-flex xs12 md10>
																	<div class="red--text" v-if="applicationRating.individualScore>0 && applicationRating.individualScore<=33.33">
																		{{ applicationRating.individualScore }}%
																	</div>
																	<div class="orange--text" v-if="applicationRating.individualScore>33.33 && applicationRating.individualScore<=66.66">
																		{{ applicationRating.individualScore }}%
																	</div>
																	<div class="green--text" v-if="applicationRating.individualScore>66.66">
																		{{ applicationRating.individualScore }}%
																	</div>
																</v-flex>
															</v-layout>
														</v-flex>
														<v-flex xs12 class="mt-6">
															<template v-for="(rating, index) in formData.ratings">
																<div :key="index">
																	<v-flex xs12 class="mb-7">
																		<v-layout row wrap>
																			<v-flex xs1>
																				<div align="center">
																					{{ index+1 }}.
																				</div>
																			</v-flex>
																			<v-flex xs11>
																				<v-layout column>
																					<v-flex xs12>
																						<b>{{ rating.name }}</b>
																					</v-flex>
																					<v-flex xs12>
																						{{ rating.description }}
																					</v-flex>
																					<v-flex xs12>
																						Weight: {{ rating.weight }}
																					</v-flex>
																					<v-flex xs12>
																						<div v-if="rating.type=='radio'">
																							<v-layout row wrap>
																								<v-flex xs12 md10>
																									<v-rating
																											background-color="grey lighten-2"
																											color="warning"
																											half-increments
																											hover
																											length="5"
																											size="17"
																											:value="applicationRating.ventureRatings[rating.id]"
																											readonly
																										></v-rating>
																								</v-flex>
																								<v-flex xs12 md2>
																									<div align="right" class="mr-5" v-if="applicationRating.ventureRatings[rating.id]">
																										<b>{{ applicationRating.ventureRatings[rating.id] }}/5</b>
																									</div>
																									<div align="right" class="mr-5" v-else>
																										<b>-/5</b>
																									</div>
																								</v-flex>
																							</v-layout>
																						</div>
																						<div v-else>
																							<div v-html="applicationRating.ventureRatings[rating.id]">

																							</div>
																						</div>
																					</v-flex>
																				</v-layout>
																				
																			</v-flex>
																		</v-layout>
																	</v-flex>
																</div>
															</template>
														</v-flex>
													</v-layout>
												</div>
											</template>
											
										</div>
									</v-layout>
								</div>
							</div>
						</v-card-text>
					</v-card>
				</div>
			</v-layout>
		</v-container>
		<logData v-if="logDataModel" v-model="logDataModel" />
	</div>
</template>

<script>
import apiCall from "@/utils/api";
import { mapGetters, mapActions } from "vuex";
import logData from "@/views/accessControl/logData";
import Vue from "vue";
import pdf from 'vue-pdf'
var numeral = require("numeral");
Vue.filter("formatNumber", function (value) {
	return numeral(value).format("0,0");
});

Vue.use(require("vue-moment"));

export default {
	components: {
		logData,
		pdf
	},
	data() {
		return {
			path: process.env.VUE_APP_API_URL,
			view: "default",
			activeTab: 'submitted',
			subTab: 'principalFounder',
			applicationTab: null,
			applicantTab: null,

			pdfsrc: null,
      		pageCount: 0,

			documentPath: null,
			docType: null,
			pdfViewDialog: false,

			loading: false,
			upgradeLoading: false,
			downgradeLoading: false,
			rejectLoading: false,
			deactivateLoading: false,

			csvLoading: false,
			pdfLoading: false,

			albumLoader: false,
			imageLoader: false,

			albumDatePicker: false,

			valid: true,
			message: "",
			color: "",
			delete: false,
			activate: false,
			confirm: false,
			lockEmail: false,

			applicationIndex: null,
			albumIndex: null,

			snackbar: false,
			inputRules: [
				(v) => !!v || "Input is required"
			],
			fileRules: [(v) => !!v || "Kindly Select a File"],

			imageDialog: false,
			imageLink: '',
			imageName: "",
			imageUrl: "",
			imageFile: "",
			imageValid: true,
			imageLoading: false,

			months: [
				"01",
				"02",
				"03",
				"04",
				"05",
				"06",
				"07",
				"08",
				"09",
				"10",
				"11",
				"12",
			],

			images: [],

			openEnded: [],
			singleSelect: [],
			multiPartSingleAnswers: [],
			multiPartMultiAnswers: [],
			multiSelects: [],
			questions: [],

			otherQuestions: [],
			childQuestions: [],
			counter: 0,

			searchTerm: null,
			searchLoader: false,
			searchButtonDisabled: false,

			filteredSubmittedApplications: false,
			filteredReviewApplications: false,
			filteredRejectedApplications: false,
			filteredSelectedForRatingApplications: false,
			filteredShortlistedApplications: false,

			newApplication: {
				id: null,
				name: null,
			},

			assignedApplication: null,

			formData: null,
			logData: {
				message: null,
				model: "App\\Models\\Application",
			},
		};
	},
	created() {
		if (this.$can("application_view")) {
			this.startSubmittedApplicationLoader();
			this.fetchSubmittedApplications(this.submittedApplicationPagination.current_page);

			this.startReviewApplicationLoader();
			this.fetchReviewApplications(this.reviewApplicationPagination.current_page);

			this.startRejectedApplicationLoader();
			this.fetchRejectedApplications(this.rejectedApplicationPagination.current_page);

			this.startSelectedForRatingApplicationLoader();
			this.fetchSelectedForRatingApplications(this.selectedForRatingApplicationPagination.current_page);

			this.startShortlistedApplicationLoader();
			this.fetchShortlistedApplications(this.shortlistedApplicationPagination.current_page);
			
			this.getQuestions();
			this.getFormData()
		}
	},
	methods: {
		...mapActions([
			"fetchSubmittedApplications",
			"startSubmittedApplicationLoader",
			"stopSubmittedApplicationLoader",
			"filterSubmittedApplications",

			"fetchReviewApplications",
			"startReviewApplicationLoader",
			"stopReviewApplicationLoader",
			"filterReviewApplications",

			"fetchRejectedApplications",
			"startRejectedApplicationLoader",
			"stopRejectedApplicationLoader",
			"filterRejectedApplications",

			"fetchSelectedForRatingApplications",
			"startSelectedForRatingApplicationLoader",
			"stopSelectedForRatingApplicationLoader",
			"filterSelectedForRatingApplications",

			"fetchShortlistedApplications",
			"startShortlistedApplicationLoader",
			"stopShortlistedApplicationLoader",
			"filterShortlistedApplications",

			"filterLogData",
			"openLogDataModel",
		]),

		showApplication(application) {
			this.assignedApplication = application;
			this.assignAnwers()
			this.changeView("show");			
		},

		assignAnwers() {				
			this.openEnded = this.assignedApplication.answers[0];
			this.singleSelect = this.assignedApplication.answers[1];
			this.multiPartSingleAnswers = this.assignedApplication.answers[2];
			this.multiPartMultiAnswers = this.assignedApplication.answers[3];
			this.multiSelects = this.assignedApplication.answers[4];
		},

		enableSearch() {
			this.searchButtonDisabled = false;
		},

		resetSubmittedSearch() {
			this.searchTerm = null;
			this.filteredSubmittedApplications = true;
			this.startSubmittedApplicationLoader();
			this.fetchSubmittedApplications(1);
		},
		resetReviewSearch() {
			this.searchTerm = null;
			this.filteredReviewApplications = true;
			this.startReviewApplicationLoader();
			this.fetchReviewApplications(1);
		},
		resetRejectedSearch() {
			this.searchTerm = null;
			this.filteredRejectedApplications = true;
			this.startRejectedApplicationLoader();
			this.fetchRejectedApplications(1);
		},
		resetSelectedForRatingSearch() {
			this.searchTerm = null;
			this.filteredSelectedForRatingApplications = true;
			this.startSelectedForRatingApplicationLoader();
			this.fetchSelectedForRatingApplications(1);
		},
		resetShortlistedSearch() {
			this.searchTerm = null;
			this.filteredShortlistedApplications = true;
			this.startShortlistedApplicationLoader();
			this.fetchShortlistedApplications(1);
		},

		checkOther(questionId, option, question) {
			if (option.option == "Other") {
				this.otherQuestions[questionId] = true;
			} else {
				this.otherQuestions[questionId] = false;
				//this.openEnded[questionId] = null;
			}
			if (option.option == "Yes"
			|| option.option == "Referred by a friend"
			|| option.option == "Yes, all of them"

			) {
				const index = this.questions.indexOf(question);
				if(this.childQuestions[questionId] === undefined){
				this.questionCount += this.questions[index].child_questions.length
				}
				
				if (this.questions[index].child_questions.length != 0) {
				this.childQuestions[questionId] = this.questions[index].child_questions
				
				}
				
				
			} 
		
			else if (option.option == "No"
			|| option.option == "Other"
			|| option.option == "No, none of them"
			|| option.option == "Majority of them"
			|| option.option == "A few of them"
			|| option.option == "Not sure"
			|| option.option == "Not Comfortable Disclosing"
			
			
			) {
				const index = this.questions.indexOf(question);
				if (this.questions[index].child_questions.length != 0) {
				this.childQuestions[questionId] = []
				if(question.question_type.name == 'Single Select Multiple Choice Question'){
					for (let i=0; i<question.child_questions.length; i++){
					if(this.singleSelect[question.child_questions[i].id] != null){
						this.singleSelect[question.child_questions[i].id] = null
						this.questionCount -= 1
					}              
					}
				} else if(question.question_type.name == 'Multi Part Single Select Multiple Choice Question'){
					for (let m=0; m<question.multi_part_questions.length; m++){
					this.multiPartSingleAnswers[question.multi_part_questions[m].id] = null
					}
				} 
				// else if(question.question_type.name == 'Multi Select Multiple Choice Questions'){
				//   for (let k=0; k<question.multi_choice_options.length; k++){
				//     this.multiSelects[question.multi_part_questions[m].id] = false
				//   }
				// }
				}
			}
			this.calculateProgress()
			},
		

		viewLog(data) {
			this.logData.message = data.id;
			this.filterLogData(this.logData);
			this.openLogDataModel();
		},

		viewDocument(doctype){
			if(doctype == 'CR12'){
				this.documentPath = this.path + '/storage/docs/' + this.assignedApplication.user.venture.cr12;
			}else{
				this.documentPath = this.path + '/storage/docs/' + this.assignedApplication.user.venture.registration_cetificate;
			}

			this.docType = doctype
			this.pdfViewDialog = true

			const loadingTask = pdf.createLoadingTask(this.documentPath);
			loadingTask.promise.then(pdfDoc => {
				this.pageCount = pdfDoc.numPages;
				this.pdfsrc = loadingTask;
			});
		},
		printPdf() {
			const win = window.open(this.documentPath, '_blank');
			if (win) {
				win.focus();
				win.print();
			} else {
				console.warn('Unable to open print window');
			}
		},
		closePDFView() {
			this.pdfsrc			= null
			this.documentPath	= null
			this.pdfViewDialog 	= false
		},

		csvDownload(type) {
            this.csvLoading = true;
            apiCall({
                url: "/api/report?type="+type,
                method: "GET",
            })
                .then((resp) => {
                    this.csvLoading = false;
                    this.downloadFile(resp, type);
                })
                .catch((error) => {
                    console.log(error.response);
                    this.csvLoading = false;
                    this.message = "An Error Occurred";
                    this.color = "error";
                    this.snackbar = true;
                });
        },

		downloadFile(response, type) {
            // It is necessary to create a new blob object with mime-type explicitly set
            // otherwise only Chrome works like it should
            var newBlob = new Blob([response], { type: "application/csv" });

            // IE doesn't allow using a blob object directly as link href
            // instead it is necessary to use msSaveOrOpenBlob
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(newBlob);
                return;
            }

            // For other browsers:
            // Create a link pointing to the ObjectURL containing the blob.
            const data = window.URL.createObjectURL(newBlob);
            var link = document.createElement("a");
            link.href = data;
			if(type=='submittedApplications'){
				link.download = 'Submitted Applications - '  + this.dateToday +  ".csv";
			}
			if(type=='reviewApplications'){
				link.download = 'Review Applications - '  + this.dateToday +  ".csv";
			}
			if(type=='rejectedApplications'){
				link.download = 'Rejected Applications - '  + this.dateToday +  ".csv";
			}
			if(type=='selectedForRatingApplications'){
				link.download = 'Selected for Rating Applications - '  + this.dateToday +  ".csv";
			}
			if(type=='shortlistedApplications'){
				link.download = 'Shortlisted Applications - '  + this.dateToday +  ".csv";
			}
            
            link.click();
            setTimeout(function () {
                // For Firefox it is necessary to delay revoking the ObjectURL
                window.URL.revokeObjectURL(data);
            }, 100);
        },

		pdfDownload() {
            this.pdfLoading = true;

            axios.defaults.headers.common['Authorization'] = localStorage.getItem('user-token');
            axios({
                url: this.path+"/api/report?type=applicationPDF",
                data: this.assignedApplication,
                method: "POST",
                responseType: "blob",
            })
                    .then((resp) => {
                        this.downloadPDFFile(resp, this.assignedApplication.user.venture.name);
                        this.pdfLoading = false;
                    })
                    .catch((error) => {
                        this.pdfLoading = false;
                    });
        },
		downloadPDFFile(response, filename) {
            // It is necessary to create a new blob object with mime-type explicitly set
            // otherwise only Chrome works like it should
            console.log('response.data', response.data)
            var newBlob = new Blob([response.data], { type: "application/pdf" });

            // IE doesn't allow using a blob object directly as link href
            // instead it is necessary to use msSaveOrOpenBlob
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(newBlob);
                return;
            }

            // For other browsers:
            // Create a link pointing to the ObjectURL containing the blob.
            const data = window.URL.createObjectURL(newBlob);
            var link = document.createElement("a");
            link.href = data;
            link.download = filename + ' ' + this.dateToday + ".pdf";
            link.click();
            setTimeout(function () {
                // For Firefox it is necessary to delay revoking the ObjectURL
                window.URL.revokeObjectURL(data);
            }, 100);
        },



		submittedSearch() {
			if (this.searchTerm == null) {
				this.searchButtonDisabled = true;
			} else {
				this.searchLoader = true;
				this.searchButtonDisabled = false;
				this.startSubmittedApplicationLoader();
				apiCall({
					url: "/api/application?type=submittedSearch&search=" + this.searchTerm,
					method: "GET",
				})
					.then((resp) => {
						this.filterSubmittedApplications(resp);
						this.searchLoader = false;
						this.stopSubmittedApplicationLoader();
						this.filteredSubmittedApplications = true;
					})
					.catch((error) => {
						console.log(error.response);
						this.searchLoader = false;
						this.stopSubmittedApplicationLoader();
						this.message = "An Error Occurred";
						this.color = "error";
						this.snackbar = true;
					});
			}
		},
		reviewSearch() {
			if (this.searchTerm == null) {
				this.searchButtonDisabled = true;
			} else {
				this.searchLoader = true;
				this.searchButtonDisabled = false;
				this.startReviewApplicationLoader();
				apiCall({
					url: "/api/application?type=reviewSearch&search=" + this.searchTerm,
					method: "GET",
				})
					.then((resp) => {
						this.filterReviewApplications(resp);
						this.searchLoader = false;
						this.stopReviewApplicationLoader();
						this.filteredReviewApplications = true;
					})
					.catch((error) => {
						console.log(error.response);
						this.searchLoader = false;
						this.stopReviewApplicationLoader();
						this.message = "An Error Occurred";
						this.color = "error";
						this.snackbar = true;
					});
			}
		},
		rejectedSearch() {
			if (this.searchTerm == null) {
				this.searchButtonDisabled = true;
			} else {
				this.searchLoader = true;
				this.searchButtonDisabled = false;
				this.startRejectedApplicationLoader();
				apiCall({
					url: "/api/application?type=rejectedSearch&search=" + this.searchTerm,
					method: "GET",
				})
					.then((resp) => {
						this.filterRejectedApplications(resp);
						this.searchLoader = false;
						this.stopRejectedApplicationLoader();
						this.filteredRejectedApplications = true;
					})
					.catch((error) => {
						console.log(error.response);
						this.searchLoader = false;
						this.stopRejectedApplicationLoader();
						this.message = "An Error Occurred";
						this.color = "error";
						this.snackbar = true;
					});
			}
		},
		selectedForRatingSearch() {
			if (this.searchTerm == null) {
				this.searchButtonDisabled = true;
			} else {
				this.searchLoader = true;
				this.searchButtonDisabled = false;
				this.startSelectedForRatingApplicationLoader();
				apiCall({
					url: "/api/application?type=selectedForRatingSearch&search=" + this.searchTerm,
					method: "GET",
				})
					.then((resp) => {
						this.filterSelectedForRatingApplications(resp);
						this.searchLoader = false;
						this.stopSelectedForRatingApplicationLoader();
						this.filteredSelectedForRatingApplications = true;
					})
					.catch((error) => {
						console.log(error.response);
						this.searchLoader = false;
						this.stopSelectedForRatingApplicationLoader();
						this.message = "An Error Occurred";
						this.color = "error";
						this.snackbar = true;
					});
			}
		},
		shortlistedSearch() {
			if (this.searchTerm == null) {
				this.searchButtonDisabled = true;
			} else {
				this.searchLoader = true;
				this.searchButtonDisabled = false;
				this.startShortlistedApplicationLoader();
				apiCall({
					url: "/api/application?type=shortlistedSearch&search=" + this.searchTerm,
					method: "GET",
				})
					.then((resp) => {
						this.filterShortlistedApplications(resp);
						this.searchLoader = false;
						this.stopShortlistedApplicationLoader();
						this.filteredShortlistedApplications = true;
					})
					.catch((error) => {
						console.log(error.response);
						this.searchLoader = false;
						this.stopShortlistedApplicationLoader();
						this.message = "An Error Occurred";
						this.color = "error";
						this.snackbar = true;
					});
			}
		},
		
		changeView(view) {
			if (view == "default") {
				
			} else if (view == "create") {
				this.getFormData();
			} else if (view == "show") {
			}
			this.view = view;
		},

		getQuestions() {
			apiCall({
				url: "/api/question?type=public",
				method: "GET",
			})
				.then((resp) => {
					this.questions = resp;
				})
				.catch((error) => {
					this.message = "An Error Occurred; Couldn't Get Form Data";
					this.color = "error";
				});
		},

		changeSubmittedApplicationPage() {
			this.startSubmittedApplicationLoader();
			if (this.filteredSubmittedApplications == true) {
				this.searchButtonDisabled = false;
				apiCall({
					url:
						"/api/application?page=" +
						this.submittedApplicationPagination.current_page +
						"&type=search&search=" +
						this.searchTerm,
					method: "GET",
				})
					.then((resp) => {
						this.filterSubmittedApplications(resp);
						this.stopSubmittedApplicationLoader();
					})
					.catch((error) => {
						this.stopSubmittedApplicationLoader();
						this.message = "An Error Occurred";
						this.color = "error";
						this.snackbar = true;
					});
			} else {
				this.fetchSubmittedApplications(this.submittedApplicationPagination.current_page);
			}
		},
		changeReviewApplicationPage() {
			this.startReviewApplicationLoader();
			if (this.filteredReviewApplications == true) {
				this.searchButtonDisabled = false;
				apiCall({
					url:
						"/api/application?page=" +
						this.reviewApplicationPagination.current_page +
						"&type=search&search=" +
						this.searchTerm,
					method: "GET",
				})
					.then((resp) => {
						this.filterReviewApplications(resp);
						this.stopReviewApplicationLoader();
					})
					.catch((error) => {
						this.stopReviewApplicationLoader();
						this.message = "An Error Occurred";
						this.color = "error";
						this.snackbar = true;
					});
			} else {
				this.fetchReviewApplications(this.reviewApplicationPagination.current_page);
			}
		},
		changeRejectedApplicationPage() {
			this.startRejectedApplicationLoader();
			if (this.filteredRejectedApplications == true) {
				this.searchButtonDisabled = false;
				apiCall({
					url:
						"/api/application?page=" +
						this.rejectedApplicationPagination.current_page +
						"&type=search&search=" +
						this.searchTerm,
					method: "GET",
				})
					.then((resp) => {
						this.filterRejectedApplications(resp);
						this.stopRejectedApplicationLoader();
					})
					.catch((error) => {
						this.stopRejectedApplicationLoader();
						this.message = "An Error Occurred";
						this.color = "error";
						this.snackbar = true;
					});
			} else {
				this.fetchRejectedApplications(this.rejectedApplicationPagination.current_page);
			}
		},
		changeSelectedForRatingApplicationPage() {
			this.startSelectedForRatingApplicationLoader();
			if (this.filteredSelectedForRatingApplications == true) {
				this.searchButtonDisabled = false;
				apiCall({
					url:
						"/api/application?page=" +
						this.selectedForRatingApplicationPagination.current_page +
						"&type=search&search=" +
						this.searchTerm,
					method: "GET",
				})
					.then((resp) => {
						this.filterSelectedForRatingApplications(resp);
						this.stopSelectedForRatingApplicationLoader();
					})
					.catch((error) => {
						this.stopSelectedForRatingApplicationLoader();
						this.message = "An Error Occurred";
						this.color = "error";
						this.snackbar = true;
					});
			} else {
				this.fetchSelectedForRatingApplications(this.selectedForRatingApplicationPagination.current_page);
			}
		},
		changeShortlistedApplicationPage() {
			this.startShortlistedApplicationLoader();
			if (this.filteredShortlistedApplications == true) {
				this.searchButtonDisabled = false;
				apiCall({
					url:
						"/api/application?page=" +
						this.shortlistedApplicationPagination.current_page +
						"&type=search&search=" +
						this.searchTerm,
					method: "GET",
				})
					.then((resp) => {
						this.filterShortlistedApplications(resp);
						this.stopShortlistedApplicationLoader();
					})
					.catch((error) => {
						this.stopShortlistedApplicationLoader();
						this.message = "An Error Occurred";
						this.color = "error";
						this.snackbar = true;
					});
			} else {
				this.fetchShortlistedApplications(this.shortlistedApplicationPagination.current_page);
			}
		},

		deleteApplication(item) {
			confirm("Are You Sure You Want to Delete Application?") && (this.delete = true);
			if (this.delete) {
				this.loading = true;
				this.applicationIndex = item.id;
				apiCall({ url: "/api/application/" + item.id, method: "DELETE" })
					.then((resp) => {
						this.message = "Application Deleted Succesfully";
						this.color = "success";
						this.snackbar = true;
						this.loading = false;
						this.delete = false;
						this.applicationIndex = null;
						this.fetchSubmittedApplications(this.submittedApplicationPagination.current_page);
					})
					.catch((error) => {
						this.message = "An Error Occurred";
						this.color = "error";
						this.snackbar = true;
						this.loading = false;
						this.delete = false;
						this.applicationIndex = null;
						console.log(error.response);
					});
			}
		},

		applicationReview(item, type, loader) {
			confirm("Please confirm if you would like to advance the application to the subsequent stage.") && (this.activate = true);
			if (this.activate) {
				if(loader=='up'){
					this.upgradeLoading = true;
				}else if(loader=='down'){
					this.downgradeLoading = true;
				}else if(loader=='downSpec'){
					this.rejectLoading = true;
				}
				
				this.applicationIndex = item.id;
				this.newApplication.id = item.id;
				apiCall({
					url: "/api/application?type=review&level="+type,
					data: this.newApplication,
					method: "POST"
				})
					.then((resp) => {
						if(type == 'reviewStage'){
							this.message = "Application Sent to Review Stage";
						}else if(type == 'shortlisted'){
							this.message = "Application Shortlisted";
						}else if(type == 'selectedForRating'){
							this.message = "Application Selected for Rating";
						}else if(type == 'rejectedStage'){
							this.message = "Application Rejected";
						}
						
						if(loader=='up'){
							this.color = "success";
						}else{
							this.color = "orange";
						}
						this.snackbar = true;
						this.upgradeLoading = false;
						this.downgradeLoading = false;
						this.rejectLoading = false;
						this.activate = false;
						this.applicationIndex = null;
						if(type=='reviewStage'){
							if(loader=='up'){
								this.fetchSubmittedApplications(this.submittedApplicationPagination.current_page);								
							}else{
								this.fetchRejectedApplications(this.rejectedApplicationPagination.current_page);
								this.fetchSelectedForRatingApplications(this.selectedForRatingApplicationPagination.current_page);
							}
							this.fetchReviewApplications(this.reviewApplicationPagination.current_page);						
						}else if(type=='rejectedStage'){
							if(loader=='up'){
								this.fetchReviewApplications(this.reviewApplicationPagination.current_page);
							}else{
								this.fetchSelectedForRatingApplications(this.selectedForRatingApplicationPagination.current_page);
								this.fetchReviewApplications(this.reviewApplicationPagination.current_page);
							}							
							this.fetchRejectedApplications(this.rejectedApplicationPagination.current_page);
						}else if(type=='selectedForRating'){
							if(loader=='up'){
								this.fetchReviewApplications(this.reviewApplicationPagination.current_page);
								this.fetchRejectedApplications(this.rejectedApplicationPagination.current_page);
							}else{
								this.fetchShortlistedApplications(this.shortlistedApplicationPagination.current_page);
							}
							this.fetchSelectedForRatingApplications(this.selectedForRatingApplicationPagination.current_page);
						}else if(type=='shortlisted'){
							if(loader=='up'){
								this.fetchSelectedForRatingApplications(this.selectedForRatingApplicationPagination.current_page);
								this.fetchShortlistedApplications(this.shortlistedApplicationPagination.current_page);
							}
						}
						
					})
					.catch((error) => {
						this.message = "An Error Occurred";
						this.color = "error";
						this.snackbar = true;
						this.upgradeLoading = false;
						this.activate = false;
						this.applicationIndex = null;
						console.log(error.response);
					});
			}
		},
		getFormData() {
			apiCall({
				url: "/api/application?type=formData",
				method: "GET",
			})
				.then((resp) => {
					this.formData = resp;
				})
				.catch((error) => {
					this.message = "An Error Occurred; Couldn't Get Form Data";
					this.color = "error";
				});
		},
	},
	computed: {
		...mapGetters([
			"submittedApplications", "submittedApplicationPagination", "submittedApplicationLoader", 
			"reviewApplications", "reviewApplicationPagination", "reviewApplicationLoader", 
			"rejectedApplications", "rejectedApplicationPagination", "rejectedApplicationLoader", 
			"selectedForRatingApplications", "selectedForRatingApplicationPagination", "selectedForRatingApplicationLoader", 
			"shortlistedApplications", "shortlistedApplicationPagination", "shortlistedApplicationLoader", 
			
			"logDataModel"
		]),
		submittedApplicationLength: function () {
			return Math.ceil(
				this.submittedApplicationPagination.total / this.submittedApplicationPagination.per_page
			);
		},
		reviewApplicationLength: function () {
			return Math.ceil(
				this.reviewApplicationPagination.total / this.reviewApplicationPagination.per_page
			);
		},
		rejectedApplicationLength: function () {
			return Math.ceil(
				this.rejectedApplicationPagination.total / this.rejectedApplicationPagination.per_page
			);
		},
		selectedForRatingApplicationLength: function () {
			return Math.ceil(
				this.selectedForRatingApplicationPagination.total / this.selectedForRatingApplicationPagination.per_page
			);
		},
		shortlistedApplicationLength: function () {
			return Math.ceil(
				this.shortlistedApplicationPagination.total / this.shortlistedApplicationPagination.per_page
			);
		},


		formatAlbumDate() {
			if (this.newAlbum.date != null) {
				const d = new Date(this.newAlbum.date);
				const year = d.getFullYear();
				const date = d.getDate();
				const month = d.getMonth();

				return date + " " + this.monthNames[month].name + " " + year;
			}
		},
		dateToday() {
			var today = new Date();

			var timestamp =
				today.getFullYear() +
				"-" +
				this.months[today.getMonth()] +
				"-" +
				("0" + today.getDate()).slice(-2);
			return timestamp;
		},
	},
};
</script>